import { ExpandMoreOutlined } from "@mui/icons-material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  MenuItem,
  TextField,
  Checkbox
} from "@mui/material";
import "../AddCoApplicant/AddCoApplicant.css";
import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Sidebar from "../../../Sidebar/Sidebar";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import TaskIcon from "@mui/icons-material/Task";
import { url } from "../../../App";
import Cookies from 'js-cookie';
import Autocomplete from '@mui/material/Autocomplete';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Select from "react-select";
// import { consoleUrl } from "../../../App";

const accordianSX = {
  boxShadow: "0px 0px 4px 1.5px rgba(0, 0, 0, 0.2)",
};

const mainAccordian = {};
const EditCoApplicant = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [data2, setData2] = useState([]);
  const [doc_type, setdoc_type] = useState("");
  const [doc_types, setdoc_types] = useState("");
  const [base64_data, setbase64_data] = useState("");
  const [base64_datas, setbase64_datas] = useState("");
  const [coapplicant_aadhar_back, setcoapplicant_aadhar_back] = useState(false);
  const [coapplicant_aadhar_front, setcoapplicant_aadhar_front] = useState(false);
  const [coapplicant_bank_statement, setcoapplicant_bank_statement] = useState([]);
  const [coapplicant_misc_doc, setcoapplicant_misc_doc] = useState([]);
  const [coapplicant_pan, setcoapplicant_pan] = useState(false);
  const [coapplicant_selfphoto, setcoapplicant_selfphoto] = useState(false);
  const [coapplicant_form60, setcoapplicant_form60] = useState(false);
  const [coapplicant_companyid, setcoapplicant_companyid] = useState(false);
  const [coapplicant_appointment_letter, setcoapplicant_appointment_letter] = useState([]);
  const [coapplicant_milkstatement, setcoapplicant_milkstatement] = useState([]);
  const [coapplicant_inside_shop_photo, setcoapplicant_inside_shop_photo] = useState([]);
  const [coapplicant_electricity_bill, setcoapplicant_electricity_bill] = useState([]);
  const [coapplicant_mothertongue, setcoapplicant_mothertongue] = useState("");
  const [coapplicant_category, setcoapplicant_category] = useState("");
  const [coapplicant_religion, setcoapplicant_religion] = useState("");
  const [coapplicant_dateofmarriage, setcoapplicant_dateofmarriage] = useState("");
  const [coapplicant_familystructure, setcoapplicant_familystructure] = useState("");
  const [businessNature, setBusinessNature] = useState("");
  const [companyType, setCompanyType] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [Gross_Monthly_Salary, setGross_Monthly_Salary] = useState(0);
  const [PF_Salary, setPF_Salary] = useState(0);
  const [ESIC_Salary, setESIC_Salary] = useState(0);
  const [Other_Dedutions_Salary, setOther_Dedutions_Salary] = useState(0);
  const [Basic_Salary, setBasic_Salary] = useState("");
  const [HRA_Salary, setHRA_Salary] = useState("");
  const [Fixed_Salary, setFixed_Salary] = useState("");
  const [Variable_Incentive, setVariable_Incentive] = useState("");
  const [Other_Allowances, setOther_Allowances] = useState("");
  const [Industry, setIndustry] = useState("");
  const [EmployerName, setEmployerName] = useState("");
  const [Work_Location,setWork_Location]=useState("");
  const [Pan_of_Employer,setPan_of_Employer]=useState("");


  const [durationWithCurrentEmployer, setDurationWithCurrentEmployer] = useState("");
  const [salaryMode, setSalaryMode] = useState("");
  const [currentSalary, setCurrentSalary] = useState("");
  const [prevSalary, setPrevSalary] = useState("");
  const [totalWorkExperience, setTotalWorkExperience] = useState("");
  const [officeNumber, setOfficeNumber] = useState("");
  const [officeHrNumber, setOfficeHrNumber] = useState("");
  const [department, setdepartment] = useState("");
  const [employeeCode, setemployeeCode] = useState("");
  const [primaryJoining, setprimaryJoining] = useState("");
  const [typeOfBusiness, setTypeOfBusiness] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [MantriName, setMantriName] = useState("");
  const [MantriNumber, setMantriNumber] = useState("");
  const [businessIncome, setBusinessIncome] = useState("");
  const [businessVintage, setbusinessVintage] = useState("");
  const [ifProfessional, setifProfessional] = useState("");
  const [ifbusiness, setifbusiness] = useState("");
  const [legalStatus, setlegalStatus] = useState("");
  const [workplace, setworkplace] = useState("");
  const [workplaceSize, setworkplaceSize] = useState("");
  const [workplaceStability, setworkplaceStability] = useState("");
  const [numberOfEmployees, setnumberOfEmployees] = useState("");
  const [businessID, setbusinessID] = useState("");
  const [mandliArr, setMandliArr] = useState([])
  const [coapplicantnumberOfActiveLoans, setcoapplicantnumberOfActiveLoans] = useState("");
  const [coapplicanttotalMonthlyActiveEmiAmount, setcoapplicanttotalMonthlyActiveEmiAmount] = useState("");
  const [demoTypes, setDemoTypes] = useState(['']);
  const [formData, setFormData] = useState([]);
  const [coapplicantName, setCoapplicantName] = useState("");
  const [coapplicantDob, setCoapplicantDob] = useState("");
  const [coapplicantGender, setCoapplicantGender] = useState("");
  const [coapplicantPhoneNumber, setCoapplicantPhoneNumber] = useState("");
  const [coapplicantEmail, setCoapplicantEmail] = useState("");
  const [coapplicantMaritalStatus, setCoapplicantMaritalStatus] = useState("");
  const [coapplicantEducationalQualification, setCoapplicantEducationalQualification] = useState("");
  const [coapplicantResidenceType, setCoapplicantResidenceType] = useState("");
  const [coapplicantAddress, setCoapplicantAddress] = useState("");
  const [coapplicantPincode, setCoapplicantPincode] = useState("");
  const [coapplicantState, setCoapplicantState] = useState("");
  const [coapplicantCity, setCoapplicantCity] = useState("");
  const [coapplicantSubDist, setCoapplicantSubDist] = useState("");
  const [coapplicantLocality, setCoapplicantLocality] = useState("");
  const [coapplicantSubDistArr, setCoapplicantSubDistArr] = useState([]);
  const [coapplicantLocalityArr, setCoapplicantLocalityArr] = useState([]);
  const [primaryCoapplicantCompanyAddress, setprimaryCoapplicantCompanyAddress] = useState("");
  const [primaryCoapplicantCompanyPincode, setprimaryCoapplicantCompanyPincode] = useState("");
  const [primaryCoapplicantCompanyState, setprimaryCoapplicantCompanyState] = useState("");
  const [primaryCoapplicantCompanyCity, setprimaryCoapplicantCompanyCity] = useState("");
  const [primaryCoapplicantCompanySubDist, setprimaryCoapplicantCompanySubDist] = useState("");
  const [primaryCoapplicantCompanyLocality, setprimaryCoapplicantCompanyLocality] = useState("");
  const [primaryCoapplicantCompanySubDistArr, setprimaryCoapplicantCompanySubDistArr] = useState([]);
  const [primaryCoapplicantCompanyLocalityArr, setprimaryCoapplicantCompanyLocalityArr] = useState([]);
  const [primaryCoapplicantCompanyLandmark, setprimaryCoapplicantCompanyLandmark] = useState("");
  const [primaryCoapplicantBusinessAddress, setprimaryCoapplicantBusinessAddress] = useState("");
  const [primaryCoapplicantBusinessPincode, setprimaryCoapplicantBusinessPincode] = useState("");
  const [primaryCoapplicantBusinessState, setprimaryCoapplicantBusinessState] = useState("");
  const [primaryCoapplicantBusinessCity, setprimaryCoapplicantBusinessCity] = useState("");
  const [primaryCoapplicantBusinessSubDist, setprimaryCoapplicantBusinessSubDist] = useState("");
  const [primaryCoapplicantBusinessLocality, setprimaryCoapplicantBusinessLocality] = useState("");
  const [primaryCoapplicantBusinessSubDistArr, setprimaryCoapplicantBusinessSubDistArr] = useState([]);
  const [primaryCoapplicantBusinessLocalityArr, setprimaryCoapplicantBusinessLocalityArr] = useState([]);
  const [primaryCoapplicantBusinessLandmark, setprimaryCoapplicantBusinessLandmark] = useState("");
  const [surrogateCoapplicantCompanyPincode, setsurrogateCoapplicantCompanyPincode] = useState("");
  const [surrogateCoapplicantCompanyCity, setsurrogateCoapplicantCompanyCity] = useState("");
  const [surrogateCoapplicantCompanyState, setsurrogateCoapplicantCompanyState] = useState("");
  const [surrogateCoapplicantCompanySubDistArr, setsurrogateCoapplicantCompanySubDistArr] = useState([]);
  const [surrogateCoapplicantCompanyLocalityArr, setsurrogateCoapplicantCompanyLocalityArr] = useState([]);
  const [surrogateCoapplicantCompanyLocality, setsurrogateCoapplicantCompanyLocality] = useState("");
  const [surrogateCoapplicantCompanySubDist, setsurrogateCoapplicantCompanySubDist] = useState("");
  const [surrogateCoapplicantBusinessPincode, setsurrogateCoapplicantBusinessPincode] = useState("");
  const [surrogateCoapplicantBusinessCity, setsurrogateCoapplicantBusinessCity] = useState("");
  const [surrogateCoapplicantBusinessState, setsurrogateCoapplicantBusinessState] = useState("");
  const [surrogateCoapplicantBusinessSubDistArr, setsurrogateCoapplicantBusinessSubDistArr] = useState([]);
  const [surrogateCoapplicantBusinessLocalityArr, setsurrogateCoapplicantBusinessLocalityArr] = useState([]);
  const [surrogateCoapplicantBusinessLocality, setsurrogateCoapplicantBusinessLocality] = useState("");
  const [surrogateCoapplicantBusinessSubDist, setsurrogateCoapplicantBusinessSubDist] = useState("");
  const [coapplicantRelationship, setCoapplicantRelationship] = useState("");
  const [coapplicantFatherName, setCoapplicantFatherName] = useState("");
  const [coapplicantBorrowerUniqueNo, setCoapplicantBorrowerUniqueNo] = useState("");
  const [coapplicantLoanId, setCoapplicantLoanId] = useState("");
  const [coapplicantProfession, setCoapplicantProfession] = useState("");
  const [coapplicantDesignation, setCoapplicantDesignation] = useState("");
  const [coapplicantBusinessName, setCoapplicantBusinessName] = useState("");
  const [coapplicantNatureOfBusiness, setCoapplicantNatureOfBusiness] = useState("");
  const [coapplicantOfficeAddress, setCoapplicantOfficeAddress] = useState("");
  const [coapplicantTotalWorkExp, setCoapplicantTotalWorkExp] = useState("");
  const [coapplicantMonthlyIncome, setCoapplicantMonthlyIncome] = useState("");
  const [coapplicantId, setCoapplicantId] = useState("");
  const [doc_typeBankStatement, setDoc_typeBankStatement] = useState("");
  const [base64_dataBankStatement, setBase64_dataBankStatement] = useState("");
  const [password, setPassword] = useState("");
  const [negativeArea, setNegativeArea] = useState(false)
  const [negativeAreaCompanyPrimary, setnegativeAreaCompanyPrimary] = useState(false)
  const [negativeAreaBusinessPrimary, setnegativeAreaBusinessPrimary] = useState(false)
  const [negativeAreaCompanySurrogate, setnegativeAreaCompanySurrogate] = useState(false)
  const [negativeAreaBusinessSurrogate, setnegativeAreaBusinessSurrogate] = useState(false)
  const [coapplicant_compute_income, setcoapplicant_compute_income] = useState(false);
  const [ekycMode, setEkycMode] = useState('');
  const [ekycStatus, setEkycStatus] = useState('');
  const [kycLink, setkycLink] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [coapplicantPanNo, setCoapplicantPanNo] = useState("");
  const [coapplicantAadhaarNo, setCoapplicantAadhaarNo] = useState("");
  const [coapplicantVoterId, setCoapplicantVoterId] = useState("");
  const [kycDocuments, setkycDocuments] = useState([]);
  const [incomeDocuments, setincomeDocuments] = useState([]);
  const [coapplicant_bank_report_documents, setcoapplicant_bank_report_documents] = useState([]);
  const [employementDocuments, setemployementDocuments] = useState([]);
  // const [coapplicant_cibil_report, setcoapplicant_cibil_report] = useState([]);
  const [businessProof, setbusinessProof] = useState([]);
  const [coapplicantLandmark, setcoapplicantLandmark] = useState("");
  const [motherMaiden, setmotherMaiden] = useState("");
  const [totalFamilyMembers, settotalFamilyMembers] = useState("");
  const [form60Available, setForm60Available] = useState(false);
  const [bankIfscCode, setBankIfscCode] = useState("");
  const [bankBranch, setBankBranch] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankType, setBankType] = useState("");
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [confirmBankAccountNumber, setconfirmBankAccountNumber] = useState("");
  const [coapplicantCreatedDate, setCoapplicantCreatedDate] = useState('');
  const [disableInputField, setDisableInputField] = useState(true);
  const [residingSince, setresidingSince] = useState("");
  const [primarySalariedofficialEmail, setprimarySalariedofficialEmail] = useState("");
  const [primarySelfEmployeedofficialEmail, setprimarySelfEmployeedofficialEmail] = useState("");

  const [typeOfLoan, setTypeOfLoan] = useState("");
  const [primaryBusinessChecked, setprimaryBusinessChecked] = useState(false);
  const [incomeMode, setIncomeMode] = useState("");
  const [primarySelfEmployeedofficialPhoneNumber, setprimarySelfEmployeedofficialPhoneNumber]  = useState("");
  const [voterIdEditable, setVoterIdEditable] = useState(false);
  const [isAddDoc, setIsAddDoc] = useState(false);

  const [a, seta] = useState({
    "Driving License": false,
    "Ration Card": false,
    "Election Card": false,
    Passport: false,
    "Self Attested Kyc": "",
    RC: false,
  });

  const [b, setb] = useState({
    ITR: "",
    "Salary Slip": "",
    "Bank Signature Verification": "",
  });

  const [c, setc] = useState({
    "Employee Id": false,
    "Hr Confirmation Doc": false,
    "Pf Letter": false,
  });
  const [d, setd] = useState({
    "GST certificate": "",
    "Shop Certificate": false,
    Gumastadhara: false,
    Udhyam: false,
    "Partnership Deed": false,
    "Company Registration Certificate": false,
    "Purchase Bill": "",
  });

  useEffect(() => {
    axios
      .post(url + "/coapplicant/getsingle", {
        token: token,
        email: email,
        coapplicant_id: state.coapplicant_id
      })
      .then(async (res) => {
        console.log(res);
        console.log(state.coapplicant_pincode);

        if (state.coapplicant_pincode) {
          try {
            const { data: response } = await axios.get(`${url}/pincode/${state.coapplicant_pincode}`, {
              headers: {
                email: email, token: token
              }
            })
            setCoapplicantSubDistArr(response.subDistricts)
          } catch (error) {
            console.log(error)
          }
        }

        if (state.coapplicant_subDistrict) {
          try {
            const { data: response } = await axios.get(`${url}/pincode/${state.coapplicant_pincode}/${state.coapplicant_subDistrict}`, {
              headers: {
                email: email, token: token
              }
            })
            setCoapplicantLocalityArr(response.locality)
          } catch (error) {
            console.log(error)
          }
        }

        if (state.coapplicant_locality) {
          checkNegativeArea(state.coapplicant_locality)
        }

        if (state.coapplicant_primary_business_details !== undefined) {
          if (state.coapplicant_primary_business_details.CompanyPinCode) {
            try {
              const { data: response } = await axios.get(`${url}/pincode/${state.coapplicant_primary_business_details.CompanyPinCode}`, {
                headers: {
                  email: email, token: token
                }
              })
              setprimaryCoapplicantCompanySubDistArr(response.subDistricts)
            } catch (error) {
              console.log(error)
            }
          }

          if (state.coapplicant_primary_business_details.BusinessPincode) {
            try {
              const { data: response } = await axios.get(`${url}/pincode/${state.coapplicant_primary_business_details.BusinessPincode}`, {
                headers: {
                  email: email, token: token
                }
              })
              setprimaryCoapplicantBusinessSubDistArr(response.subDistricts)
            } catch (error) {
              console.log(error)
            }
          }
        }

        if (state.coapplicant_primary_business_details !== undefined) {
          if (state.coapplicant_primary_business_details.CompanySubDistrict) {
            try {
              const { data: response } = await axios.get(`${url}/pincode/${state.coapplicant_primary_business_details.CompanyPinCode}/${state.coapplicant_primary_business_details.CompanySubDistrict}`, {
                headers: {
                  email: email, token: token
                }
              })
              setprimaryCoapplicantCompanyLocalityArr(response.locality)
            } catch (error) {
              console.log(error)
            }
          }

          if (state.coapplicant_primary_business_details.BusinessSubDist) {
            try {
              const { data: response } = await axios.get(`${url}/pincode/${state.coapplicant_primary_business_details.BusinessPincode}/${state.coapplicant_primary_business_details.BusinessSubDist}`, {
                headers: {
                  email: email, token: token
                }
              })
              setprimaryCoapplicantBusinessLocalityArr(response.locality)
            } catch (error) {
              console.log(error)
            }
          }
        }

        if (state.coapplicant_primary_business_details !== undefined) {
          if (state.coapplicant_primary_business_details.CompanyLocality) {
            checkNegativePrimaryCompanyArea(state.coapplicant_primary_business_details.CompanyLocality, setprimaryCoapplicantCompanyLocality, 'CompanyLocality')
          }

          if (state.coapplicant_primary_business_details.BusinessLocality) {
            checkNegativePrimaryBusinessArea(state.coapplicant_primary_business_details.BusinessLocality, setprimaryCoapplicantBusinessLocality, 'BusinessLocality')
          }
        }

        if (state.coapplicant_surrogate_business_details !== undefined) {
          if (state.coapplicant_surrogate_business_details.companyLocality) {
            checkNegativePrimaryCompanyArea(state.coapplicant_surrogate_business_details.companyLocality, setsurrogateCoapplicantCompanyLocality, 'companyLocality')
          }
          if (state.coapplicant_surrogate_business_details.businessLocality) {
            checkNegativePrimaryBusinessArea(state.coapplicant_surrogate_business_details.businessLocality, setsurrogateCoapplicantBusinessLocality, 'businessLocality')
          }
        }

        if (state.coapplicant_surrogate_business_details !== undefined) {
          state.coapplicant_surrogate_business_details.forEach(async (detail) => {

            if (detail.companyPinCode) {
              const { data: subDistData } = await axios.get(`${url}/pincode/${detail.companyPinCode}`, {
                headers: {
                  token: token,
                  email: email
                }
              });
              setsurrogateCoapplicantCompanySubDistArr(subDistData.subDistricts);
            }

            if (detail.businessPinCode) {
              const { data: subDistData } = await axios.get(`${url}/pincode/${detail.businessPinCode}`, {
                headers: {
                  token: token,
                  email: email
                }
              });
              setsurrogateCoapplicantBusinessSubDistArr(subDistData.subDistricts);
            }
          })
        };

        if (state.coapplicant_surrogate_business_details !== undefined) {
          state.coapplicant_surrogate_business_details.forEach(async (detail) => {
            if (detail.companySubDist) {
              const { data: subDistData } = await axios.get(`${url}/pincode/${detail.companyPinCode}/${detail.companySubDist}`, {
                headers: {
                  token: token,
                  email: email
                }
              });
              setsurrogateCoapplicantCompanyLocalityArr(subDistData.locality);
            }

            if (detail.businessSubDist) {
              const { data: subDistData } = await axios.get(`${url}/pincode/${detail.businessPinCode}/${detail.businessSubDist}`, {
                headers: {
                  token: token,
                  email: email
                }
              });
              setsurrogateCoapplicantBusinessLocalityArr(subDistData.locality);
            }
          })
        };

        // console.log(res);
        if (res.data.logout === true) {
          toast.error(res.data.message);
          setTimeout(() => {
            navigate("/");
          }, 3000);
        }
        else {
          setcoapplicant_selfphoto(
            res.data[0].coapplicant_selfphoto
              ? res.data[0].coapplicant_selfphoto.doc_name
              : ""
          );

          setcoapplicant_aadhar_front(
            res.data[0].coapplicant_aadhar_front
              ? res.data[0].coapplicant_aadhar_front.doc_name
              : ""
          );
          setcoapplicant_aadhar_back(
            res.data[0].coapplicant_aadhar_back
              ? res.data[0].coapplicant_aadhar_back.doc_name
              : ""
          );

          setcoapplicant_pan(
            res.data[0].coapplicant_pan
              ? res.data[0].coapplicant_pan.doc_name
              : ""
          );

          setcoapplicant_form60(
            res.data[0].coapplicant_form60
              ? res.data[0].coapplicant_form60.doc_name
              : ""
          );
          setcoapplicant_companyid(
            res.data[0].coapplicant_companyid
              ? res.data[0].coapplicant_companyid.doc_name
              : ""
          );

          setCoapplicantCreatedDate(res.data[0].coapplicant_created_date !== undefined ? res.data[0].coapplicant_created_date : "")

          var f = [];
          if (res.data[0].coapplicant_bank_statement) {
            for (let n = 0; n < res.data[0].coapplicant_bank_statement.length; n++) {
              f.push({
                doc_name: res.data[0].coapplicant_bank_statement[n].doc_name,
              });
            }
            // console.log(f);
            setcoapplicant_bank_statement(f);
          }

          var g = [];
          if (res.data[0].coapplicant_misc_doc) {
            for (let o = 0; o < res.data[0].coapplicant_misc_doc.length; o++) {
              g.push({
                doc_name: res.data[0].coapplicant_misc_doc[o].doc_name,
              });
            }
            // console.log(g);
            setcoapplicant_misc_doc(g);
          }

          var c = [];
          if (res.data[0].coapplicant_milkstatement) {
            for (let n = 0; n < res.data[0].coapplicant_milkstatement.length; n++) {
              c.push({
                doc_name: res.data[0].coapplicant_milkstatement[n].doc_name,
              });
            }
            // console.log(f);
            setcoapplicant_milkstatement(c);
          }

          var e = [];
          if (res.data[0].coapplicant_electricity_bill) {
            for (let n = 0; n < res.data[0].coapplicant_electricity_bill.length; n++) {
              e.push({
                doc_name: res.data[0].coapplicant_electricity_bill[n].doc_name,
              });
            }
            // console.log(f);
            setcoapplicant_electricity_bill(e);
          }
          var k = [];
          if (res.data[0].coapplicant_inside_shop_photo) {
            for (let n = 0; n < res.data[0].coapplicant_inside_shop_photo.length; n++) {
              k.push({
                doc_name: res.data[0].coapplicant_inside_shop_photo[n].doc_name,
              });
            }
            // console.log(f);
            setcoapplicant_inside_shop_photo(k);
          }

          var j = [];
          if (res.data[0].coapplicant_appointment_letter) {
            for (let n = 0; n < res.data[0].coapplicant_appointment_letter.length; n++) {
              j.push({
                doc_name: res.data[0].coapplicant_appointment_letter[n].doc_name,
              });
            }
            // console.log(f);
            setcoapplicant_appointment_letter(j);
          }

          var cbrd = [];
          if (res.data[0].coapplicant_bank_report_documents) {
            for (let n = 0; n < res.data[0].coapplicant_bank_report_documents.length; n++) {
              cbrd.push({
                doc_name: res.data[0].coapplicant_bank_report_documents[n].doc_name,
              });
            }
            // console.log(f);
            setcoapplicant_bank_report_documents(cbrd);
          }

          var ccr = [];
          if (res.data[0].coapplicant_cibil_report) {
            for (let n = 0; n < res.data[0].coapplicant_cibil_report.length; n++) {
              ccr.push({
                doc_name: res.data[0].coapplicant_cibil_report[n].doc_name,
              });
            }
            // console.log(f);
            // setcoapplicant_cibil_report(ccr);
          }
        }
      })
      .catch((err) => {
        // console.log(err);
      });

    if (!state) {
      navigate("/");
    } else {
      console.log(state, "state")
      setresidingSince(state.coapplicant_residing_since);
      setBankIfscCode(state.coapplicant_bank_ifsc);
      setBankBranch(state.coapplicant_bank_branch);
      setBankName(state.coapplicant_bank_name);
      setBeneficiaryName(state.coapplicant_beneficiary_name);
      setBankType(state.coapplicant_bank_type);
      setBankAccountNumber(state.coapplicant_bank_account);
      setconfirmBankAccountNumber(state.coapplicant_bank_account);
      settotalFamilyMembers(state.coapplicant_totalFamilyMembers);
      setmotherMaiden(state.coapplicant_mother_maiden);
      setcoapplicantLandmark(state.coapplicant_landmark);
      setCoapplicantId(state.coapplicant_id);
      setCoapplicantName(state.coapplicant_name);
      setCoapplicantDob(state.coapplicant_dob);
      setCoapplicantGender(state.coapplicant_gender);
      setCoapplicantPhoneNumber(state.coapplicant_mobile);
      setCoapplicantEmail(state.coapplicant_email);
      setCoapplicantMaritalStatus(state.coapplicant_marital_status);
      setCoapplicantEducationalQualification(state.coapplicant_education);
      setCoapplicantResidenceType(state.coapplicant_residence_type);
      setCoapplicantAddress(state.coapplicant_residence_address);
      setCoapplicantPincode(state.coapplicant_pincode);
      setCoapplicantState(state.coapplicant_state);
      setCoapplicantSubDist(state.coapplicant_subDistrict)
      setCoapplicantLocality(state.coapplicant_locality)
      setCoapplicantCity(state.coapplicant_city);
      setCoapplicantRelationship(state.coapplicant_relationship);
      setCoapplicantFatherName(state.coapplicant_fathername);
      setCoapplicantBorrowerUniqueNo(state.coapplicant_borrower_uniqueno);
      setCoapplicantLoanId(state.coapplicant_loan_id);
      setCoapplicantProfession(state.coapplicant_profession_type);
      setCoapplicantDesignation(state.coapplicant_designation);
      setCoapplicantBusinessName(state.coapplicant_business_name);
      setCoapplicantNatureOfBusiness(state.coapplicant_nature_of_business);
      setCoapplicantOfficeAddress(state.coapplicant_office_address);
      setCoapplicantTotalWorkExp(state.coapplicant_total_exp);
      setCoapplicantMonthlyIncome(state.coapplicant_monthly_income);
      setcoapplicant_compute_income(state.coapplicant_compute_income);
      setcoapplicant_mothertongue(state.coapplicant_mother_tongue);
      setcoapplicant_category(state.coapplicant_category);
      setcoapplicant_religion(state.coapplicant_religion);
      setcoapplicant_dateofmarriage(state.coapplicant_date_of_marriage);
      setcoapplicant_familystructure(state.coapplicant_family_structure);
      setcoapplicantnumberOfActiveLoans(state.coapplicant_number_of_active_loans);
      setcoapplicanttotalMonthlyActiveEmiAmount(state.coapplicant_total_monthly_active_emi_amount);
      setEkycMode(state.ekycMode);
      setEkycStatus(state.borrower_digikyc_status);
      setCoapplicantPanNo(state.coapplicant_panno)
      setCoapplicantAadhaarNo(state.coapplicant_aadharno)
      setCoapplicantVoterId(state.coapplicant_voterno)
      setForm60Available(state.coapplicant_form60_available)
      if (state.coapplicant_primary_business_details !== undefined) {
        setBusinessNature(state.coapplicant_primary_business_details?.NatureOfBusiness)
        setCompanyType(state.coapplicant_primary_business_details?.CompanyType)
        setDesignationName(state.coapplicant_primary_business_details?.DesignationName)
        setDurationWithCurrentEmployer(state.coapplicant_primary_business_details?.DurationWithCurrentEmployer)
        setSalaryMode(state.coapplicant_primary_business_details?.SalaryMode)
        setCurrentSalary(state.coapplicant_primary_business_details?.CurrentSalaryIncome)
        setPrevSalary(state.coapplicant_primary_business_details?.PreviousSalary)
        setTotalWorkExperience(state.coapplicant_primary_business_details?.TotalWorkExperienceInMonths)
        setOfficeNumber(state.coapplicant_primary_business_details?.OfficeNumber)
        setOfficeHrNumber(state.coapplicant_primary_business_details?.OfficeHrNumber)
        setdepartment(state.coapplicant_primary_business_details?.Department)
        setemployeeCode(state.coapplicant_primary_business_details?.EmployeeCode)
        setprimaryJoining(state.coapplicant_primary_business_details?.DateOfJoining)
        setprimarySalariedofficialEmail(state.coapplicant_primary_business_details?.OfficialEmailID)
        setprimaryCoapplicantCompanyAddress(state.coapplicant_primary_business_details?.CompanyAddress)
        setprimaryCoapplicantCompanyPincode(state.coapplicant_primary_business_details?.CompanyPinCode)
        setprimaryCoapplicantCompanyState(state.coapplicant_primary_business_details?.CompanyState)
        setprimaryCoapplicantCompanyCity(state.coapplicant_primary_business_details?.CompanyCity)
        setprimaryCoapplicantCompanySubDist(state.coapplicant_primary_business_details?.CompanySubDistrict)
        setprimaryCoapplicantCompanyLocality(state.coapplicant_primary_business_details?.CompanyLocality)
        setprimaryCoapplicantCompanyLandmark(state.coapplicant_primary_business_details?.CompanyLandmark)
        setTypeOfBusiness(state.coapplicant_primary_business_details?.BusinessType)
        setBusinessName(state.coapplicant_primary_business_details?.BusinessName)
        setMantriName(state.coapplicant_primary_business_details?.MantriName)
        setMantriNumber(state.coapplicant_primary_business_details?.MantriNumber)
        setBusinessIncome(state.coapplicant_primary_business_details?.BusinessIncome)
        setbusinessVintage(state.coapplicant_primary_business_details?.BusinessVintage)
        setifProfessional(state.coapplicant_primary_business_details?.IfProfessional)
        setifbusiness(state.coapplicant_primary_business_details?.IfBusiness)
        setlegalStatus(state.coapplicant_primary_business_details?.LegalStatus)
        setworkplace(state.coapplicant_primary_business_details?.Workplace)
        setworkplaceSize(state.coapplicant_primary_business_details?.WorkplaceSize)
        setworkplaceStability(state.coapplicant_primary_business_details?.WorkplaceStability)
        setnumberOfEmployees(state.coapplicant_primary_business_details?.NumberOfEmployees)
        setbusinessID(state.coapplicant_primary_business_details?.BusinessID)
        setprimarySelfEmployeedofficialEmail(state.coapplicant_primary_business_details?.BusinessEmailID)
        setprimaryCoapplicantBusinessAddress(state.coapplicant_primary_business_details?.BusinessAddress)
        setprimaryCoapplicantBusinessPincode(state.coapplicant_primary_business_details?.BusinessPincode)
        setprimaryCoapplicantBusinessState(state.coapplicant_primary_business_details?.BusinessState)
        setprimaryCoapplicantBusinessCity(state.coapplicant_primary_business_details?.BusinessCity)
        setprimaryCoapplicantBusinessSubDist(state.coapplicant_primary_business_details?.BusinessSubDist)
        setprimaryCoapplicantBusinessLocality(state.coapplicant_primary_business_details?.BusinessLocality)
        setprimaryCoapplicantBusinessLandmark(state.coapplicant_primary_business_details?.BusinessLandmark)
        setprimaryBusinessChecked(state.coapplicant_primary_business_details?.PrimaryBusinessChecked);
        setIncomeMode(state.coapplicant_primary_business_details?.IncomeMode);
        setTypeOfLoan(state.coapplicant_primary_business_details?.TypeOfLoan);
        setprimarySelfEmployeedofficialPhoneNumber(state.coapplicant_primary_business_details?.BusinessPhoneNumber)
        const businessDetails = state?.coapplicant_primary_business_details;
        setGross_Monthly_Salary(
          businessDetails.Gross_Monthly_Salary ?? ""
        );

        setFixed_Salary(
          businessDetails.Fixed_Salary ?? ""
        );

        setVariable_Incentive(
          businessDetails.Variable_Incentive ?? ""
        );

        setOther_Allowances(
          businessDetails.Allowances ?? ""
        );

        setIndustry(
          businessDetails.Industry ?? ""
        );

        setEmployerName(
          businessDetails.EmployerName ?? ""
        );

        // Existing initialization
        setDurationWithCurrentEmployer(
          businessDetails.DurationWithCurrentEmployer ?? ""
        );

        setSalaryMode(
          businessDetails.SalaryMode ?? ""
        );

        setCurrentSalary(
          businessDetails.CurrentSalaryIncome ?? ""
        );

        setPrevSalary(
          businessDetails.PreviousSalary ?? ""
        );

        setTotalWorkExperience(
          businessDetails.TotalWorkExperienceInMonths ?? ""
        );
        setWork_Location(
          businessDetails.Work_Location ?? ""
        );
        setPan_of_Employer(
          businessDetails.Pan_of_Employer ?? ""
        );
        setPF_Salary(
          businessDetails.PF_Salary ?? 0
        );
        setBasic_Salary(
          businessDetails.Basic_Salary ?? 0
        );
        setHRA_Salary(
          businessDetails.HRA_Salary ?? 0
        );
        setESIC_Salary(
          businessDetails.ESIC_Salary ?? 0
        );
        setOther_Dedutions_Salary(
          businessDetails.Other_Dedutions_Salary ?? 0
        );
      }

      let demotypeTemp = []

      if (state.coapplicant_surrogate_business_details !== undefined) {
        for (let i = 0; i < state.coapplicant_surrogate_business_details.length; i++) {
          demotypeTemp.push(state.coapplicant_surrogate_business_details[i].professionType)
        }
        setDemoTypes(demotypeTemp);
        console.log(demotypeTemp)
        setFormData(state.coapplicant_surrogate_business_details);
        const salariedData = state.coapplicant_surrogate_business_details?.find(obj => obj.professionType === "SALARIED");
        const selfEmployedData = state.coapplicant_surrogate_business_details?.find(obj => obj.professionType === "SELF-EMPLOYED");

        if (salariedData) {
          setsurrogateCoapplicantCompanyPincode(salariedData?.companyPinCode);
          setsurrogateCoapplicantCompanyCity(salariedData?.companyCity);
          setsurrogateCoapplicantCompanyState(salariedData?.companyState);
          setsurrogateCoapplicantCompanySubDist(salariedData?.companySubDist);
          setsurrogateCoapplicantCompanyLocality(salariedData?.companyLocality);
        }

        if (selfEmployedData) {
          setsurrogateCoapplicantBusinessPincode(selfEmployedData?.businessPinCode);
          setsurrogateCoapplicantBusinessCity(selfEmployedData?.businessCity);
          setsurrogateCoapplicantBusinessState(selfEmployedData?.businessState);
          setsurrogateCoapplicantBusinessSubDist(selfEmployedData?.businessSubDist);
          setsurrogateCoapplicantBusinessLocality(selfEmployedData?.businessLocality);
        }
      }

      //showing in edit page(other kyc)
      let vals = [];
      if (state?.coapplicant_driving_license) {
        vals = [
          ...vals,
          {
            label: "Driving License",
            value: "Driving License",
            id: "Driving License",
          },
        ];
      }
      if (state?.coapplicant_ration_card) {
        vals = [
          ...vals,
          { label: "Ration Card", value: "Ration Card", id: "Ration Card" },
        ];
      }
      if (state?.coapplicant_election_card) {
        vals = [
          ...vals,
          {
            label: "Election Card",
            value: "Election Card",
            id: "Election Card",
          },
        ];
      }
      if (state?.coapplicant_passport) {
        vals = [
          ...vals,
          { label: "Passport", value: "Passport", id: "Passport" },
        ];
      }
      if (state?.coapplicant_self_attested_kyc) {
        vals = [
          ...vals,
          {
            label: "Self Attested Kyc",
            value: "Self Attested Kyc",
            id: "Self Attested Kyc",
          },
        ];
      }
      if (state?.coapplicant_rc) {
        vals = [
          ...vals,
          { label: "RC", value: "RC", id: "RC" },
        ];
      }
      setkycDocuments(vals);

      //logo visible code(other kyc)
      let val = { ...a };

      val =
        state?.coapplicant_driving_license
          ? { ...val, "Driving License": true }
          : { ...val, "Driving License": false };
      val =
        state?.coapplicant_ration_card
          ? { ...val, "Ration Card": true }
          : { ...val, "Ration Card": false };
      val =
        state?.coapplicant_election_card
          ? { ...val, "Election Card": true }
          : { ...val, "Election Card": false };
      val =
        state?.coapplicant_passport
          ? { ...val, Passport: true }
          : { ...val, Passport: false };
      val =
        state?.coapplicant_self_attested_kyc
          ? {
            ...val,
            "Self Attested Kyc": state.coapplicant_self_attested_kyc.length,
          }
          : { ...val, "Self Attested Kyc": "" };
      val =
        state?.coapplicant_rc
          ? { ...val, RC: true }
          : { ...val, RC: false };

      seta(val);

      //showing in edit page (other income)
      let vall = [];

      if (state?.coapplicant_itr) {
        vall = [
          ...vall,
          { label: "ITR", value: "ITR", id: "ITR" },
        ];
      }

      if (state?.coapplicant_salaryslip) {
        vall = [
          ...vall,
          { label: "Salary Slip", value: "Salary Slip", id: "Salary Slip" },
        ];
      }

      if (state?.coapplicant_signature_verification) {
        vall = [
          ...vall,
          {
            label: "Bank Signature Verification",
            value: "Bank Signature Verification",
            id: "Bank Signature Verification",
          },
        ];
      }

      setincomeDocuments(vall);

      //logo visible code(other income)
      let vaa = { ...b };
      vaa =
        state?.coapplicant_itr
          ? { ...vaa, ITR: state.coapplicant_itr.length }
          : { ...vaa, ITR: "" };
      vaa =
        state?.coapplicant_salaryslip
          ? { ...vaa, "Salary Slip": state.coapplicant_salaryslip.length }
          : { ...vaa, "Salary Slip": "" };

      vaa =
        state?.coapplicant_signature_verification
          ? {
            ...vaa,
            "Bank Signature Verification":
              state.coapplicant_signature_verification.length,
          }
          : { ...vaa, "Bank Signature Verification": "" };

      setb(vaa)

      //showing in edit page code(other employee)
      let va = [];

      if (state?.coapplicant_employeeid) {
        va = [
          ...va,
          { label: "Employee Id", value: "Employee Id", id: "Employee Id" },
        ];
      }

      if (state?.coapplicant_hr_confirmation_doc) {
        va = [
          ...va,
          {
            label: "Hr Confirmation Doc",
            value: "Hr Confirmation Doc",
            id: "Hr Confirmation Doc",
          },
        ];
      }

      if (state?.coapplicant_pf_letter) {
        va = [
          ...va,
          { label: "Pf Letter", value: "Pf Letter", id: "Pf Letter" },
        ];
      }

      setemployementDocuments(va);

      //logo visible code(other employee)
      let vas = { ...c };
      vas =
        state?.coapplicant_employeeid
          ? { ...vas, "Employee Id": true }
          : { ...vas, "Employee Id": false };
      vas =
        state?.coapplicant_hr_confirmation_doc
          ? { ...vas, "Hr Confirmation Doc": true }
          : { ...vas, "Hr Confirmation Doc": false };
      vas =
        state?.coapplicant_pf_letter
          ? { ...vas, "Pf Letter": true }
          : { ...vas, "Pf Letter": false };

      setc(vas);

      //showing in edit page (business)
      let br = [];

      if (state?.coapplicant_gst_certificate) {
        br = [
          ...br,
          {
            label: "GST certificate",
            value: "GST certificate",
            id: "GST certificate",
          },
        ];
      }

      if (state?.coapplicant_shop_certificate) {
        br = [
          ...br,
          {
            label: "Shop Certificate",
            value: "Shop Certificate",
            id: "Shop Certificate",
          },
        ];
      }

      if (state?.coapplicant_gumastadhara) {
        br = [
          ...br,
          { label: "Gumastadhara", value: "Gumastadhara", id: "Gumastadhara" },
        ];
      }

      if (state?.coapplicant_udhyam) {
        br = [
          ...br,
          { label: "Udhyam", value: "Udhyam", id: "Udhyam" },
        ];
      }

      if (state?.coapplicant_partnership_deed) {
        br = [
          ...br,
          {
            label: "Partnership Deed",
            value: "Partnership Deed",
            id: "Partnership Deed",
          },
        ];
      }

      if (state?.coapplicant_company_registration_certificate) {
        br = [
          ...br,
          {
            label: "Company Registration Certificate",
            value: "Company Registration Certificate",
            id: "Company Registration Certificate",
          },
        ];
      }

      if (state?.coapplicant_purchase_bill) {
        br = [
          ...br,
          {
            label: "Purchase Bill",
            value: "Purchase Bill",
            id: "Purchase Bill",
          },
        ];
      }
      setbusinessProof(br);

      //logo visible code(business)
      let brp = { ...d };
      brp =
        state?.coapplicant_gst_certificate
          ? { ...brp, "GST certificate": state.coapplicant_gst_certificate.length }
          : { ...brp, "GST certificate": "" };
      brp =
        state?.coapplicant_shop_certificate
          ? { ...brp, "Shop Certificate": true }
          : { ...brp, "Shop Certificate": false };
      brp =
        state?.coapplicant_gumastadhara
          ? { ...brp, Gumastadhara: true }
          : { ...brp, Gumastadhara: false };
      brp =
        state?.coapplicant_udhyam
          ? { ...brp, Udhyam: true }
          : { ...brp, Udhyam: false };
      brp =
        state?.coapplicant_partnership_deed
          ? { ...brp, "Partnership Deed": true }
          : { ...brp, "Partnership Deed": false };
      brp =
        state.coapplicant_company_registration_certificate
          ? { ...brp, "Company Registration Certificate": true }
          : { ...brp, "Company Registration Certificate": false };
      brp =
        state.coapplicant_purchase_bill
          ? { ...brp, "Purchase Bill": state.coapplicant_purchase_bill.length }
          : { ...brp, "Purchase Bill": "" };

      setd(brp);

      axios
        .post(url + "/loan/borrowertoloan", {
          token: token,
          email: email,
          borrower_uniqueno: state.coapplicant_borrower_uniqueno,
        })
        .then((res) => {
          if (res.data.auth === true) {
            // console.log(res);
            setData2(res.data.message);
          } else {
            // console.log(res);
            setData2([]);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }

    if (email === "rupesh.bishnoi@credin.in") {
      setVoterIdEditable(true);
      setIsAddDoc(true)
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          // console.log(res);
          setVoterIdEditable(res.data[0].permission.borrower_voterid);
          setIsAddDoc(res.data[0].permission.add_co_borrower_document);
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err.message);
        })
    }

    //eslint-disable-next-line
  }, [token, email, state, navigate]);

  const natureOfBusinessArray = [
    "FINANCIAL INSTITUTE OTHER THAN NBFC",
    "NON-BANK FINANCIAL COMPANY",
    "FINANCIAL INTERMEDIATERIES",
    "MEDIA AND ENTERTAINMENT",
    "BANKING",
    "JEWELRY AND ORNAMENTS",
    "CHEMICALS",
    "ADVERTISING AND PROMOTION",
    "EDUCATION",
    "FREIGHT AND LOGISTICS",
    "REAL ESTATE AND BUILDER",
    "AUTOMOBILES",
    "CLOTH AND TEXTILES",
    "PHARMA AND MEDICINE",
    "ARCHITECT",
    "DOCTOR",
    "HOTEL AND HOSPITALITY",
    "IRON AND STEEL",
    "AGRICULTURE",
    "ACCOUNT CONSULTING",
    "CONTRACTOR AND FRANCHISEE",
    "ENGINEERING PRODUCTS",
    "IT AND SOFTWARE",
    "INSURANCE CIVIL CONTRACTOR",
    "TELECOM  HARDWARE AND DISTRIBUTION",
    "AGRICULTURE PROCESSING",
    "BPO AND KPO",
    "CEMENT MANUFACTURING STOCKING AND ALLIED ACTI",
    "ELECTRICAL ELECTRONICS MANUFACTURING SERVICE",
    "FMCG",
    "FURNITURE AND WOOD PRODUCTS",
    "IT HARDWARE AND PERIPHERALS",
    "NATURAL RESOURCES RELATED",
    "PAPER PRODUCTS AND ALLIED ACTIVITIES",
    "PLASTICS AND  ALLIED ACTIVITIES",
    "PUBLISHING AND PRINT MEDIA",
    "RETAIL SHOPS AND PROVISIONS RELATED",
    "RUBBER INDUSTRY  AND ALLIED PRODUCTS",
    "SHIPPING INDUSTRY",
    "OTHERS",
  ];

  const handleChangeComputeIncome = (event) => {
    setcoapplicant_compute_income(event.target.checked);
  };

  const handleChangeCoapplicantPhoneNumber = (e) => {
    if (e.target.value.length <= 10) {
      setCoapplicantPhoneNumber(e.target.value);
    }
  };

  const handleChangeSearchPincode = (e) => {
    if (e.target.value.length <= 6) {
      setCoapplicantPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setCoapplicantCity(res.data.District);
            setCoapplicantState(res.data.State);
            setCoapplicantSubDistArr(res.data.subDistricts)
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setCoapplicantCity("");
            setCoapplicantState("");
            setCoapplicantSubDist("")
            setCoapplicantSubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const handlePrimaryCompanyPincode = (e) => {
    if (e.target.value.length <= 6) {
      setprimaryCoapplicantCompanyPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          console.log(res);
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setprimaryCoapplicantCompanyCity(res.data.District);
            setprimaryCoapplicantCompanyState(res.data.State);
            setprimaryCoapplicantCompanySubDistArr(res.data.subDistricts)
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setprimaryCoapplicantCompanyCity("");
            setprimaryCoapplicantCompanyState("");
            setprimaryCoapplicantCompanySubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const handlePrimaryBusinessPincode = (e) => {
    if (e.target.value.length <= 6) {
      setprimaryCoapplicantBusinessPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          console.log(res);
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setprimaryCoapplicantBusinessCity(res.data.District);
            setprimaryCoapplicantBusinessState(res.data.State);
            setprimaryCoapplicantBusinessSubDistArr(res.data.subDistricts)
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setprimaryCoapplicantBusinessCity("");
            setprimaryCoapplicantBusinessState("");
            setprimaryCoapplicantBusinessSubDist("");
            setprimaryCoapplicantBusinessSubDistArr([])
            
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    }
  };

  const handleSurrogateCompanyPincode = (e) => {
    if (e.target.value.length <= 6) {
      setsurrogateCoapplicantCompanyPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setsurrogateCoapplicantCompanyCity(res.data.District);
            setsurrogateCoapplicantCompanyState(res.data.State);
            setsurrogateCoapplicantCompanySubDistArr(res.data.subDistricts);
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setsurrogateCoapplicantCompanyCity("");
            setsurrogateCoapplicantCompanyState("");
            setsurrogateCoapplicantCompanySubDist("");
            setsurrogateCoapplicantCompanySubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });
    }
  };

  const handleSurrogateBusinessPincode = (e) => {
    if (e.target.value.length <= 6) {
      setsurrogateCoapplicantBusinessPincode(e.target.value);
    }
    if (e.target.value.length === 6) {
      axios
        .get(`${url}/pincode/${e.target.value}`, {
          headers: {
            token: token, email: email
          }
        })
        .then((res) => {
          if (res.data.Status === "Success") {
            toast.success(res.data.Message);
            setsurrogateCoapplicantBusinessCity(res.data.District);
            setsurrogateCoapplicantBusinessState(res.data.State);
            setsurrogateCoapplicantBusinessSubDistArr(res.data.subDistricts);
          } else {
            toast.error(res.data.Message + " for the entered pincode");
            setsurrogateCoapplicantBusinessCity("");
            setsurrogateCoapplicantBusinessState("");
            setsurrogateCoapplicantBusinessSubDist("")
            setsurrogateCoapplicantBusinessSubDistArr([])
            return;
          }
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err);
        });
    }
  };

  const handleSubDistChange = async (e) => {
    setCoapplicantSubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${coapplicantPincode}/${e.target.value}`, {
        headers: {
          email: email, token: token
        }
      })
      setCoapplicantLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubDistPrimaryCompanyChange = async (e) => {
    console.log(e.target.value)
    setprimaryCoapplicantCompanySubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${primaryCoapplicantCompanyPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setprimaryCoapplicantCompanyLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubDistPrimaryBusinessChange = async (e) => {
    console.log(e.target.value)
    setprimaryCoapplicantBusinessSubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${primaryCoapplicantBusinessPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setprimaryCoapplicantBusinessLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubDistSurrogateCompanyChange = async (e) => {
    console.log(e.target.value)
    setsurrogateCoapplicantCompanySubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${surrogateCoapplicantCompanyPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setsurrogateCoapplicantCompanyLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubDistSurrogateBusinessChange = async (e) => {
    console.log(e.target.value)
    setsurrogateCoapplicantBusinessSubDist(e.target.value);
    try {
      const { data: localityRes } = await axios.get(`${url}/pincode/${surrogateCoapplicantBusinessPincode}/${e.target.value}`, {
        headers: {
          token: token, email: email
        }
      })
      console.log(localityRes)
      setsurrogateCoapplicantBusinessLocalityArr(localityRes.locality)
    } catch (err) {
      console.log(err)
    }
  }

  const handlebusinessName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setBusinessName(e.target.value);
    }
  };

  const handleSubmitCoApplicantDetails = (e) => {
    e.preventDefault();
    setOpen(true);
    axios
      .post(url + "/coapplicant/update", {
        token: token,
        email: email,
        coapplicant_id: coapplicantId,
        coapplicant_name: coapplicantName,
        coapplicant_dob: coapplicantDob,
        coapplicant_gender: coapplicantGender,
        coapplicant_mobile: coapplicantPhoneNumber,
        coapplicant_email: coapplicantEmail,
        coapplicant_marital_status: coapplicantMaritalStatus,
        coapplicant_education: coapplicantEducationalQualification,
        coapplicant_residence_type: coapplicantResidenceType,
        coapplicant_residence_address: coapplicantAddress,
        coapplicant_pincode: coapplicantPincode,
        coapplicant_state: coapplicantState,
        coapplicant_city: coapplicantCity,
        coapplicant_subDistrict: coapplicantSubDist,
        coapplicant_locality: coapplicantLocality,
        coapplicant_landmark: coapplicantLandmark,
        coapplicant_relationship: coapplicantRelationship,
        coapplicant_fathername: coapplicantFatherName,
        coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        coapplicant_loan_id: coapplicantLoanId,
        coapplicant_profession_type: coapplicantProfession,
        coapplicant_designation: coapplicantDesignation,
        coapplicant_business_name: coapplicantBusinessName,
        coapplicant_office_address: coapplicantOfficeAddress,
        coapplicant_total_exp: coapplicantTotalWorkExp,
        coapplicant_monthly_income: coapplicantMonthlyIncome,
        coapplicant_nature_of_business: coapplicantNatureOfBusiness,
        coapplicant_compute_income: coapplicant_compute_income,
        coapplicant_mother_tongue: coapplicant_mothertongue,
        coapplicant_category: coapplicant_category,
        coapplicant_religion: coapplicant_religion,
        coapplicant_date_of_marriage: coapplicant_dateofmarriage,
        coapplicant_family_structure: coapplicant_familystructure,
        coapplicant_mother_maiden: motherMaiden,
        coapplicant_totalFamilyMembers: totalFamilyMembers,
        coapplicant_residing_since: residingSince,
        coapplicant_voterno: coapplicantVoterId
      })
      .then((res) => {
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
    setTimeout(() => {
      setOpen(false)
      // navigate("/borrower/detail/:loanid");
    }, 3000);
  };

  const handlePrimaryBusinessDetails = (e) => {
    e.preventDefault();
    const primaryformData = {
      NatureOfBusiness: businessNature,
      CompanyType: companyType,
      DesignationName: designationName,
      DurationWithCurrentEmployer: durationWithCurrentEmployer,
      SalaryMode: salaryMode,
      CurrentSalaryIncome: currentSalary,
      PreviousSalary: prevSalary,
      TotalWorkExperienceInMonths: totalWorkExperience,
      OfficeNumber: officeNumber,
      OfficeHrNumber: officeHrNumber,
      Department: department,
      EmployeeCode: employeeCode,
      DateOfJoining: primaryJoining,
      CompanyAddress: primaryCoapplicantCompanyAddress,
      CompanyPinCode: primaryCoapplicantCompanyPincode,
      CompanyState: primaryCoapplicantCompanyState,
      CompanyCity: primaryCoapplicantCompanyCity,
      CompanySubDistrict: primaryCoapplicantCompanySubDist,
      CompanyLocality: primaryCoapplicantCompanyLocality,
      CompanyLandmark: primaryCoapplicantCompanyLandmark,
      BusinessType: typeOfBusiness,
      BusinessName: businessName,
      MantriName: MantriName,
      MantriNumber: MantriNumber,
      BusinessEmail: primarySalariedofficialEmail,
      BusinessPhoneNumber: primarySelfEmployeedofficialPhoneNumber,
      IncomeMode: incomeMode,
      BusinessIncome: businessIncome,
      BusinessVintage: businessVintage,
      IfProfessional: ifProfessional,
      IfBusiness: ifbusiness,
      LegalStatus: typeOfLoan === "CATTLE LOAN" ? "PROPRIETORSHIP" : legalStatus,
      Workplace: workplace,
      WorkplaceSize: workplaceSize,
      CurrentWorkplace: workplaceStability,
      NumberOfEmployees: numberOfEmployees,
      BusinessID: typeOfLoan === "CATTLE LOAN" ? "Milk Statement" : businessID,
      BusinessAddress: primaryCoapplicantBusinessAddress,
      BusinessPincode: primaryCoapplicantBusinessPincode,
      BusinessState: primaryCoapplicantBusinessState,
      BusinessCity: primaryCoapplicantBusinessCity,
      BusinessSubDist: primaryCoapplicantBusinessSubDist,
      BusinessLocality: primaryCoapplicantBusinessLocality,
      BusinessLandmark: primaryCoapplicantBusinessLandmark,
      PrimaryBusinessChecked: primaryBusinessChecked,
      TypeOfLoan: typeOfLoan,
      Gross_Monthly_Salary:Gross_Monthly_Salary,
      Fixed_Salary:Fixed_Salary,
      Variable_Incentive:Variable_Incentive,
      Allowances:Other_Allowances,
      Industry:Industry,
      EmployerName:EmployerName,
      Work_Location:Work_Location,
      Pan_of_Employer:Pan_of_Employer,
      PF_Salary:PF_Salary,
      ESIC_Salary:ESIC_Salary,
      Other_Dedutions_Salary:Other_Dedutions_Salary,
      Basic_Salary:Basic_Salary,
      HRA_Salary:HRA_Salary
      
    };
    console.log(primaryformData)

    axios
      .post(url + "/coapplicant/primary/details", {
        token: token,
        email: email,
        coapplicant_id: coapplicantId,
        coapplicant_loan_id: coapplicantLoanId,
        coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        coapplicant_primary_business_details: primaryformData
      })
      .then((res) => {
        console.log(res)
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const handleObligationDetails = (e) => {
    e.preventDefault();
    axios
      .post(url + "/coapplicant/obligation/details", {
        token: token,
        email: email,
        coapplicant_id: coapplicantId,
        coapplicant_loan_id: coapplicantLoanId,
        coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        coapplicant_number_of_active_loans: coapplicantnumberOfActiveLoans,
        coapplicant_total_monthly_active_emi_amount: coapplicanttotalMonthlyActiveEmiAmount
      })
      .then((res) => {
        console.log(res)
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const uploadSelfPhoto = (e) => {
    setOpen(true);
    let selfPhoto = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Self Photo in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcoapplicant_selfphoto(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(selfPhoto[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "self_photo",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPancard = (e) => {
    setOpen(true);
    let pancard = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Pancard in Jpg or Png format only");
      return;
    }

    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    if (doc_type === "JPG") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcoapplicant_pan(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(pancard[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "pan_card",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadAadharCardFront = (e) => {
    let aadharCardFront = e.target.files;
    if (e.target.files[0] === undefined) {
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      toast.error("Please upload Aadhar Card Front in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    if (doc_type === "JPG") {
      doc_type = "jpeg";
    }
    setdoc_type(doc_type)
    setcoapplicant_aadhar_front(e.target.files[0].name);

    let reader = new FileReader();
    reader.readAsDataURL(aadharCardFront[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      setbase64_data(base64_data);
    };
  };

  const uploadAadharCardBack = (e) => {
    let aadharCardBack = e.target.files;
    if (e.target.files[0] === undefined) {
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      toast.error("Please upload Aadhar Card Back in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    if (doc_type === "JPG") {
      doc_type = "jpeg";
    }
    setdoc_types(doc_type)
    setcoapplicant_aadhar_back(e.target.files[0].name);

    let reader = new FileReader();
    reader.readAsDataURL(aadharCardBack[0]);
    reader.onload = (e) => {
      let base64_datas = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      setbase64_datas(base64_datas);
    };
  };

  const uploadAadharCard = (e) => {
    setOpen(true);
    axios
      .post(url + "/coapplicant/adddocument", {
        coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        coapplicant_id: coapplicantId,
        doc_name: "aadhar_front",
        doc_names: "aadhar_back",
        doc_type: doc_type,
        doc_types: doc_types,
        fileName: base64_data,
        fileNames: base64_datas,
        token: token,
        email: email,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === true) {
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err.message);
      });
  }

  const uploadBankStatement = (e) => {
    let bankStatement = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg" && doc_type !== "pdf") {
      toast.error("Please upload Bank Statement in Jpg or Png or Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let a = [];
    a.push(e.target.files[0].name);
    // console.log(a);
    setcoapplicant_bank_statement((prevValues) => [...prevValues, a]);
    let reader = new FileReader();
    reader.readAsDataURL(bankStatement[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      setDoc_typeBankStatement(doc_type);
      setBase64_dataBankStatement(base64_data);
    };
  };

  const uploadBankReportDocuments = (e) => {
    setOpen(true);
    let bankReportDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf" && doc_type !== "xlsx") {
      setOpen(false);
      toast.error(
        "Please upload Bank Report Documents in Pdf or xlsx format only"
      );
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let a = [];
    a.push(e.target.files[0].name);
    setcoapplicant_bank_report_documents((prevValues) => [...prevValues, a]);
    let reader = new FileReader();
    reader.readAsDataURL(bankReportDocuments[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_bank_report_documents",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const handleSubmitBankStatement = () => {
    setOpen(true);
    if (doc_typeBankStatement === "" || base64_dataBankStatement === "") {
      setOpen(false);
      toast.error("Please upload bank statement before submitting");
      return;
    }
    axios
      .post(url + "/coapplicant/adddocument", {
        token: token,
        email: email,
        coapplicant_id: coapplicantId,
        doc_name: "coapplicant_bank_statement",
        doc_type: doc_typeBankStatement,
        coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        coapplicant_bank_statement_password: password,
        fileName: base64_dataBankStatement,
      })
      .then((res) => {
        // console.log(res);
        if (res.data.auth === true) {
          // toast.dismiss("custom");
          setOpen(false);
          toast.success(res.data.message);
        } else {
          // console.log(res.data.message);
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err.message);
      });
  };

  const uploadCoapplicantForm60 = (e) => {
    setOpen(true);
    let form60 = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Co-Applicant Form 60 in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcoapplicant_form60(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(form60[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_form60",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
          coapplicant_form60_available: form60Available
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            // toast.dismiss("custom");
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadMiscellaneousDocuments = (e) => {
    setOpen(true);
    let miscellaneousDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg" && doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Miscellaneous Documents in Jpg or Png or pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    setcoapplicant_misc_doc((prevValues) => [...prevValues, b]);
    let reader = new FileReader();
    reader.readAsDataURL(miscellaneousDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_misc_doc",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  // const uploadcibilReport = (e) => {
  //   setOpen(true);
  //   let cibilReport = e.target.files;
  //   if (e.target.files[0] === undefined) {
  //     setOpen(false);
  //     return;
  //   }
  //   let doc_type = e.target.files[0].name.split(".").pop();
  //   console.log(doc_type);
  //   if (doc_type !== "pdf") {
  //     setOpen(false);
  //     toast.error("Please upload Cibil Report in pdf format only");
  //     return;
  //   }
  //   if (doc_type === "jpg") {
  //     doc_type = "jpeg";
  //   }
  //   // console.log(doc_type);
  //   let b = [];
  //   b.push(e.target.files[0].name);
  //   setcoapplicant_cibil_report((prevValues) => [...prevValues, b]);

  //   let reader = new FileReader();
  //   reader.readAsDataURL(cibilReport[0]);
  //   reader.onload = (e) => {
  //     // console.log(e.target.result);
  //     let base64_data;
  //     base64_data = e.target.result.split("base64,").pop();
  //     axios
  //       .post(url + "/coapplicant/adddocument", {
  //         coapplicant_id: coapplicantId,
  //         coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
  //         doc_name: "coapplicant_cibil_report",
  //         doc_type: doc_type,
  //         token: token,
  //         email: email,
  //         fileName: base64_data,
  //       })
  //       .then((res) => {
  //         // console.log(res);
  //         if (res.data.auth === true) {
  //           setOpen(false);
  //           toast.success(res.data.message);
  //         } else {
  //           // console.log(res.data.message);
  //           setOpen(false);
  //           toast.error(res.data.message);
  //         }
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         setOpen(false);
  //         toast.error(err.message);
  //       });
  //   };
  // };

  const uploaditr = (e) => {
    setOpen(true);
    // console.log(e.target.files, "rohit");
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload ITR in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_itr",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res, "tt");
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setb({ ...b, ITR: res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadSalarySlip = (e) => {
    setOpen(true);
    let salarySlip = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Salary Slip in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    let reader = new FileReader();
    reader.readAsDataURL(salarySlip[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_salaryslip",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setb({ ...b, "Salary Slip": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadbankSignature = (e) => {
    setOpen(true);
    let BankSignature = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error(
        "Please upload Bank Signature Verification in Pdf format only"
      );
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    let reader = new FileReader();
    reader.readAsDataURL(BankSignature[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_signature_verification",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setb({ ...b, "Bank Signature Verification": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadEmployeeId = (e) => {
    setOpen(true);
    let employeeId = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Employee Id in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    setc({ ...c, "Employee Id": true });
    let reader = new FileReader();
    reader.readAsDataURL(employeeId[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_employeeid",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadhrDoc = (e) => {
    setOpen(true);
    let hrDocs = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Hr Confirmation Doc in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);

    setc({ ...c, "Hr Confirmation Doc": true });
    let reader = new FileReader();
    reader.readAsDataURL(hrDocs[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_hr_confirmation_doc",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadpfLetter = (e) => {
    setOpen(true);
    let pfLetters = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Pf Letter in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    setc({ ...c, "Pf Letter": true });
    let reader = new FileReader();
    reader.readAsDataURL(pfLetters[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_pf_letter",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadCompanyId = (e) => {
    setOpen(true);
    let companyId = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "jpeg" && doc_type !== "png") {
      setOpen(false);
      toast.error("Please upload Company ID in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setcoapplicant_companyid(e.target.files[0].name);
    let reader = new FileReader();
    reader.readAsDataURL(companyId[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_companyid",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadAppointmentLetter = (e) => {
    setOpen(true);
    let appointmentLetter = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Appointment Letter in PDF format only");
      return;
    }

    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);

    let b = [];
    b.push(e.target.files[0].name);
    // console.log(b);
    setcoapplicant_appointment_letter((prevValues) => [...prevValues, b]);

    let reader = new FileReader();
    reader.readAsDataURL(appointmentLetter[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:application/${doc_type};base64,`,
        "",
        ""
      );
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_appointment_letter",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadMilkStatement = (e) => {
    setOpen(true);
    let milkStatement = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload  Milk Statement in PDF format only");
      return;
    }

    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    // console.log(b);
    setcoapplicant_milkstatement((prevValues) => [...prevValues, b]);

    let reader = new FileReader();
    reader.readAsDataURL(milkStatement[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:application/${doc_type};base64,`,
        "",
      );
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_milkstatement",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };


  const uploadGST = (e) => {
    setOpen(true);
    let GST = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload GST certificate in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    let reader = new FileReader();
    reader.readAsDataURL(GST[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_gst_certificate",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setd({ ...d, "GST certificate": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadShopCertificate = (e) => {
    setOpen(true);
    let ShopCertificate = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Shop Certificate in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, "Shop Certificate": true });
    let reader = new FileReader();
    reader.readAsDataURL(ShopCertificate[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_shop_certificate",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadGumastadhara = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Gumastadhara in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);

    setd({ ...d, Gumastadhara: true });
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_gumastadhara",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);

            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);

          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadUdhyam = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Udhyam in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, Udhyam: true });

    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_udhyam",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPartnershipDeed = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Partnership Deed in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);

    setd({ ...d, "Partnership Deed": true });
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_partnership_deed",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadCompanyRegistrationCertificate = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error(
        "Please upload Company Registration Certificate in Pdf format only"
      );
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    setd({ ...d, "Company Registration Certificate": true });
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_company_registration_certificate",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPurchaseBill = (e) => {
    setOpen(true);
    let itrDocuments = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Purchase Bill in Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let reader = new FileReader();
    reader.readAsDataURL(itrDocuments[0]);
    reader.onload = (e) => {
      // console.log(e.target.result);
      let base64_data;
      base64_data = e.target.result.split("base64,").pop();

      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_purchase_bill",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            setd({ ...d, "Purchase Bill": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadBusinessPhoto = (e) => {
    setOpen(true);
    let businessPhoto = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "jpeg" && doc_type !== "png") {
      setOpen(false);
      toast.error("Please upload Business Photo in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    // console.log(b);
    setcoapplicant_inside_shop_photo((prevValues) => [...prevValues, b]);
    let reader = new FileReader();
    reader.readAsDataURL(businessPhoto[0]);
    reader.onload = (e) => {
      let base64_data = e.target.result.replace(
        `data:image/${doc_type};base64,`,
        "",
        ""
      );
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_inside_shop_photo",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadRationCard = (e) => {
    setOpen(true);
    let RationCard = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Ration Card in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    seta({ ...a, "Ration Card": true });

    let reader = new FileReader();
    reader.readAsDataURL(RationCard[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_ration_card",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadDrivingLicense = (e) => {
    setOpen(true);
    let DrivingLicense = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Driving License in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    seta({ ...a, "Driving License": true });
    let reader = new FileReader();
    reader.readAsDataURL(DrivingLicense[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_driving_license",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadPassport = (e) => {
    setOpen(true);
    let Passport = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Passport in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    seta({ ...a, Passport: true });
    let reader = new FileReader();
    reader.readAsDataURL(Passport[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_passport",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadElectionCard = (e) => {
    setOpen(true);
    let ElectionCard = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Election Card in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    seta({ ...a, "Election Card": true });
    let reader = new FileReader();
    reader.readAsDataURL(ElectionCard[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_election_card",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadselfAttestedKyc = (e) => {
    setOpen(true);
    let SelfAttestedKyc = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload Self Attested Kyc in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    let reader = new FileReader();
    reader.readAsDataURL(SelfAttestedKyc[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          doc_name: "coapplicant_self_attested_kyc",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
            seta({ ...a, "Self Attested Kyc": res.data.doc_length });
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadRC = (e) => {
    setOpen(true);
    let RC = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg") {
      setOpen(false);
      toast.error("Please upload RC in Jpg or Png format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    seta({ ...a, RC: true });

    let reader = new FileReader();
    reader.readAsDataURL(RC[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          "",
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          "",
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_rc",
          doc_type: doc_type,
          token: token,
          email: email,
          fileName: base64_data,
        })

        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const uploadElectricityBill = (e) => {
    setOpen(true);
    let electricityBill = e.target.files;
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    let doc_type = e.target.files[0].name.split(".").pop();
    if (doc_type !== "jpg" && doc_type !== "png" && doc_type !== "jpeg" && doc_type !== "pdf") {
      setOpen(false);
      toast.error("Please upload Electricity Bill in Jpg or Png or Pdf format only");
      return;
    }
    if (doc_type === "jpg") {
      doc_type = "jpeg";
    }
    // console.log(doc_type);
    let b = [];
    b.push(e.target.files[0].name);
    // console.log(b);
    setcoapplicant_electricity_bill((prevValues) => [...prevValues, b]);
    let reader = new FileReader();
    reader.readAsDataURL(electricityBill[0]);
    reader.onload = (e) => {
      let base64_data;
      if (doc_type === "pdf") {
        base64_data = e.target.result.replace(
          `data:application/${doc_type};base64,`,
          ""
        );
      } else {
        base64_data = e.target.result.replace(
          `data:image/${doc_type};base64,`,
          ""
        );
      }
      // console.log(base64_data);
      axios
        .post(url + "/coapplicant/adddocument", {
          token: token,
          email: email,
          coapplicant_id: coapplicantId,
          doc_name: "coapplicant_electricity_bill",
          doc_type: doc_type,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
          fileName: base64_data,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.auth === true) {
            setOpen(false);
            toast.success(res.data.message);
          } else {
            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);
          setOpen(false);
          toast.error(err.message);
        });
    };
  };

  const handleSelectBorrower = (event) => {
    setCoapplicantBorrowerUniqueNo(event.target.value);
    setCoapplicantLoanId("");
    // console.log(event.target.value);
    axios
      .post(url + "/loan/borrowertoloan", {
        token: token,
        email: email,
        borrower_uniqueno: event.target.value,
      })
      .then((res) => {
        if (res.data.auth === true) {
          // console.log(res);
          setData2(res.data.message);
        } else {
          // console.log(res);
          toast.error(res.data.message);
          setData2([]);
        }
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const checkNegativeArea = async (locality) => {
    setCoapplicantLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setNegativeArea(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativePrimaryCompanyArea = async (locality) => {
    setprimaryCoapplicantCompanyLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaCompanyPrimary(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativePrimaryBusinessArea = async (locality) => {
    setprimaryCoapplicantBusinessLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaBusinessPrimary(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativeSurrogateCompanyArea = async (locality) => {
    setsurrogateCoapplicantCompanyLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaCompanySurrogate(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const checkNegativeSurrogateBusinessArea = async (locality) => {
    setsurrogateCoapplicantBusinessLocality(locality)
    try {
      const { data: response } = await axios.get(`${url}/pincode/negativearea/${locality}`, {
        headers: {
          token: token, email: email
        }
      })
      if (response.Status === 'Error') {
        return toast.error(response.message)
      }
      setnegativeAreaBusinessSurrogate(response.negativeArea)
    } catch (err) {
      console.log(err)
    }
  }

  const handleCoapplicantName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setCoapplicantName(e.target.value);
    }
  };

  const handlefatherName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setCoapplicantFatherName(e.target.value);
    }
  };

  const handleAddSurrogate = () => {
    setDemoTypes([...demoTypes, '']);
    setFormData([...formData, {}]);
  };

  const handleSurrogateProfession = (index, value) => {
    const newDemoTypes = [...demoTypes];
    newDemoTypes[index] = value;
    setDemoTypes(newDemoTypes);
  };

  const handleSurrogateInputChange = (index, fieldName, value) => {
    const newFormData = [...formData];
    newFormData[index] = { ...newFormData[index], [fieldName]: value };
    setFormData(newFormData);
  };

  const handleSurrogateDetails = (e) => {
    e.preventDefault();

    const inputFieldsData = demoTypes.map((demoType, index) => {
      const data = {
        professionType: demoType,
      };
      if (demoType === "SELF-EMPLOYED") {
        data.businessIncome = formData[index]?.businessIncome || "";
        data.businessVintage = formData[index]?.businessVintage || "";
        data.typeOfBusiness = formData[index]?.typeOfBusiness || "";
        data.businessName = formData[index]?.businessName || "";
        data.mantriName = formData[index]?.mantriName || "";
        data.mantriNumber = formData[index]?.mantriNumber || "";
        data.businessIncomeMode = formData[index]?.businessIncomeMode || "";
        data.businessEmailId = formData[index]?.businessEmailId || "";
        data.businessAddress = formData[index]?.businessAddress || "";
        data.businessPinCode = surrogateCoapplicantBusinessPincode;
        data.businessState = surrogateCoapplicantBusinessState;
        data.businessCity = surrogateCoapplicantBusinessCity;
        data.businessSubDist = surrogateCoapplicantBusinessSubDist;
        data.businessLocality = surrogateCoapplicantBusinessLocality;
        data.businessLandmark = formData[index]?.businessLandmark || "";
      } else {
        data.designationName = formData[index]?.designationName || "";
        data.natureOfBusiness = formData[index]?.natureOfBusiness || "";
        data.durationWithCurrentEmployer = formData[index]?.durationWithCurrentEmployer || "";
        data.salaryMode = formData[index]?.salaryMode || "";
        data.currentSalary = formData[index]?.currentSalary || "";
        data.prevSalary = formData[index]?.prevSalary || "";
        data.totalWorkExperience = formData[index]?.totalWorkExperience || "";
        data.officeNumber = formData[index]?.officeNumber || "";
        data.officeHrNumber = formData[index]?.officeHrNumber || "";
        data.dateofJoining = formData[index]?.dateofJoining || "";
        data.officialEmailId = formData[index]?.officialEmailId || "";
        data.companyAddress = formData[index]?.companyAddress || "";
        data.companyPinCode = surrogateCoapplicantCompanyPincode;
        data.companyState = surrogateCoapplicantCompanyState;
        data.companyCity = surrogateCoapplicantCompanyCity;
        data.companySubDist = surrogateCoapplicantCompanySubDist;
        data.companyLocality = surrogateCoapplicantCompanyLocality;
        data.companyLandmark = formData[index]?.companyLandmark || "";
      }
      return data;
    });

    console.log(inputFieldsData);

    axios
      .post(url + "/coapplicant/surrogate/details", {
        token: token,
        email: email,
        coapplicant_id: coapplicantId,
        coapplicant_loan_id: coapplicantLoanId,
        coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        coapplicant_surrogate_business_details: inputFieldsData
      })
      .then((res) => {
        console.log(res)
        if (res.data.auth === true) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err);
      });

  };

  const handleMandliChange = (e, newValue) => {
    setBusinessName(newValue);
  }

  const mandliSuggestions = async (e) => {
    try {
      const { data: filteredMandlis } = await axios.get(`${url}/mandli/filter/${e.target.value}`, {
        headers: { token: token, email: email }
      })
      if (!filteredMandlis.auth) {
        toast.error(filteredMandlis.message)
        return
      }
      setMandliArr(filteredMandlis.mandli)
      return
    } catch (error) {
      return
    }
  }
  console.log(demoTypes)

  const handleEkyc = (ekyc) => {
    setOpen(true);
    console.log(ekyc);
    axios
      .post(url + `/ekyc/${ekyc}`, {
        borrowerId: state.coapplicant_id,
        token: token,
        email: email,
        customer: 'Coapplicant'
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === '1') {
          setOpenDialog(true);
        } else if (res.data.auth === true) {
          setOpen(false);
          toast.success(res.data.message);
          setkycLink(res.data.kycLink);
        } else {
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err);
      });
  };

  const handleChoice = async (choice) => {
    console.log("Selected choice", choice);
    let userChoice;
    if (!choice) {
      userChoice = 'eKyc'
    } else {
      userChoice = choice;
    }
    try {
      setOpenDialog(false);
      const callKycApi = await axios.post(url + "/borrower/initiatekyc", {
        kycType: userChoice,
        borrowerNo: coapplicantId,
        borrowerMobile: coapplicantPhoneNumber,
        borrowerName: coapplicantName
      })

      if (callKycApi.data.auth === true) {
        console.log('arrived');
        toast.success('Please check coapplicant mobile for kyc link', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000,
        });
        window.alert(`KYC initiated. Please check coapplicant mobile for link`);
        let kyc = userChoice === 'eKyc' ? 'DIGIO EKYC' : 'DIGIO PHYSICAL';
        setEkycMode(kyc);
        setEkycStatus('INITIATED');
        setOpen(false);
      } else {
        console.log(callKycApi.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function copyLinkToClipboard() {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(kycLink)
        .then(() => {
          toast.success("Link copied to clipboard successfully");
        })
        .catch((error) => {
          toast.error("Error copying Link to clipboard:", error);
        });
    } else {
      toast.error(
        "Clipboard API not supported or writeText property not available"
      );
    }
  }


  const kyc = [
    {
      value: "Driving License",
      label: "Driving License",
      id: "Driving License",
    },
    { value: "Ration Card", label: "Ration Card", id: "Ration Card" },
    { value: "Election Card", label: "Election Card", id: "Election Card" },
    { value: "Passport", label: "Passport", id: "Passport" },
    {
      value: "Self Attested Kyc",
      label: "Self Attested Kyc",
      id: "Self Attested Kyc",
    },
    { value: "RC", label: "RC", id: "RC" },
  ];

  const Income = [
    { value: "ITR", label: "ITR", id: "ITR" },
    { value: "Salary Slip", label: "Salary Slip", id: "Salary Slip" },
    {
      value: "Bank Signature Verification",
      label: "Bank Signature Verification",
      id: "Bank Signature Verification",
    },
  ];

  const Employement = [
    { value: "Employee Id", label: "Employee Id", id: "Employee Id" },
    {
      value: "Hr Confirmation Doc",
      label: "Hr Confirmation Doc",
      id: "Hr Confirmation Doc",
    },
    { value: "Pf Letter", label: "Pf Letter", id: "Pf Letter" },
  ];

  const Business = [
    {
      value: "GST certificate",
      label: "GST certificate",
      id: "GST certificate",
    },
    {
      value: "Shop Certificate",
      label: "Shop Certificate",
      id: "Shop Certificate",
    },
    { value: "Gumastadhara", label: "Gumastadhara", id: "Gumastadhara" },
    { value: "Udhyam", label: "Udhyam", id: "Udhyam" },
    {
      value: "Partnership Deed",
      label: "Partnership Deed",
      id: "Partnership Deed",
    },
    {
      value: "Company Registration Certificate",
      label: "Company Registration Certificate",
      id: "Company Registration Certificate",
    },
    { value: "Purchase Bill", label: "Purchase Bill", id: "Purchase Bill" },
  ];

  const handlekycdocuments = (e) => {
    // console.log("kyc", e);
    const fetchFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(fetchFees);
    setkycDocuments(fetchFees);
  };

  const handleincomedocuments = (e) => {
    // console.log("income", e);
    const incomeFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(incomeFees);
    setincomeDocuments(incomeFees);
  };

  const handleemployeedocuments = (e) => {
    // console.log("emp", e);
    const employeFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(employeFees);
    setemployementDocuments(employeFees);
  };

  const handlebusinessdocuments = (e) => {
    // console.log("emp", e);
    const businessFees = e.map((val) => {
      return {
        label: val.label,
        value: val.value,
        id: val.value,
      };
    });
    // console.log(businessFees);
    setbusinessProof(businessFees);
  };

  const abc = (e) => {
    // console.log(e, "aa");
    if (e.target.name === "Driving License") {
      uploadDrivingLicense(e);
    }
    if (e.target.name === "Ration Card") {
      uploadRationCard(e);
    }
    if (e.target.name === "Election Card") {
      uploadElectionCard(e);
    }
    if (e.target.name === "Passport") {
      uploadPassport(e);
    }
    if (e.target.name === "Self Attested Kyc") {
      uploadselfAttestedKyc(e);
    }
    if (e.target.name === "RC") {
      uploadRC(e);
    }
  };

  const bac = (e) => {
    // console.log(e, "aa");
    if (e.target.name === "ITR") {
      uploaditr(e);
    }
    if (e.target.name === "Salary Slip") {
      uploadSalarySlip(e);
    }
    if (e.target.name === "Bank Signature Verification") {
      uploadbankSignature(e);
    }
  };

  const KycBox = (label) => {
    // console.log(label);

    if (
      label === "Self Attested Kyc"
    ) {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input type="file" name={label} onChange={(e) => abc(e)} />
          <div>
            {a[label] ? (
              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
            ) : (
              ""
            )}
            {a[label] ? `(${a[label]})` : ""}
          </div>
          <br />
        </div>
      );
    } else {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input type="file" name={label} onChange={(e) => abc(e)} />
          <div>
            {a[label] ? (
              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
            ) : (
              ""
            )}
          </div>
          <br />
        </div>
      );
    }
  };

  const bcc = (e) => {
    // console.log(e, "aa");
    if (e.target.name === "Employee Id") {
      uploadEmployeeId(e);
    }
    if (e.target.name === "Hr Confirmation Doc") {
      uploadhrDoc(e);
    }
    if (e.target.name === "Pf Letter") {
      uploadpfLetter(e);
    }
  };

  const businessRegistration = (e) => {
    // console.log(e, "aa");
    if (e.target.name === "GST certificate") {
      uploadGST(e);
    }
    if (e.target.name === "Shop Certificate") {
      uploadShopCertificate(e);
    }
    if (e.target.name === "Gumastadhara") {
      uploadGumastadhara(e);
    }
    if (e.target.name === "Udhyam") {
      uploadUdhyam(e);
    }
    if (e.target.name === "Partnership Deed") {
      uploadPartnershipDeed(e);
    }
    if (e.target.name === "Company Registration Certificate") {
      uploadCompanyRegistrationCertificate(e);
    }
    if (e.target.name === "Purchase Bill") {
      uploadPurchaseBill(e);
    }
  };

  const incomeBox = (label) => {
    // console.log(label);
    // console.log(b,"ABC")
    return (
      <div className="input-item-kyc">
        <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
        <input type="file" name={label} onChange={(e) => bac(e)} />
        <div>
          {b[label] ? (
            <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
          ) : (
            ""
          )}
          {b[label] ? `(${b[label]})` : ""}
        </div>
        <br />
      </div>
    );
  };

  const employeBox = (label) => {
    // console.log(label);
    return (
      <div className="input-item-kyc">
        <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
        <input type="file" name={label} onChange={(e) => bcc(e)} />
        {c[label] ? <TaskIcon sx={{ color: "green", fontSize: "2rem" }} /> : ""}
        <br />
      </div>
    );
  };

  const businessBox = (label) => {
    // console.log(label);
    if (label === "GST certificate" || label === "Purchase Bill") {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input
            type="file"
            name={label}
            onChange={(e) => businessRegistration(e)}
          />
          <div>
            {d[label] ? (
              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
            ) : (
              ""
            )}
            {d[label] ? `(${d[label]})` : ""}
          </div>
          <br />
        </div>
      );
    } else {
      return (
        <div className="input-item-kyc">
          <label style={{ fontWeight: "bold" }}>{`${label}`}</label>
          <input
            type="file"
            name={label}
            onChange={(e) => businessRegistration(e)}
          />
          <div>
            {d[label] ? (
              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
            ) : (
              ""
            )}
          </div>
          <br />
        </div>
      );
    }
  };

  const handleCheckboxChange = () => {
    setForm60Available(!form60Available);
  };
//old
  // const handleChangeCollectionBankIfscCode = (e) => {
  //   if (e.target.value.length <= 11) {
  //     setBankIfscCode(e.target.value);
  //   }
  //   if (e.target.value.length === 11) {
  //     axios
  //       .post(consoleUrl + "/credin/v4", {
  //         IFSC: e.target.value,
  //       })
  //       .then((res) => {
  //         if (res.data.Message === "Bank Details Found") {
  //           toast.success(res.data.Message);
  //           setBankName(res.data.Bank);
  //           setBankBranch(res.data.Branch);
  //         } else {
  //           toast.error(res.data.Message);
  //           setBankName("");
  //           setBankBranch("");
  //         }
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error(err);
  //       });
  //   }
  // };

//new
  const handleChangeCollectionBankIfscCode = (e) => {
    console.log(e.target.value,"e")

    if (e.target.value.length <= 11) {
      setBankIfscCode(e.target.value);
    }
    if (e.target.value.length === 11) {
      axios
        .post(url + "/api/fetch/bank/details", {
          IFSC: e.target.value,
          token: token,
          email: email,
        })
        .then((res) => {
          console.log(res,"res")
          if (res.data.success) {
            toast.success("Bank Details Found");
            setBankName(res.data.bank);
            setBankBranch(res.data.branch);
          } else {
            toast.error(res.data.message);
            setBankName("");
            setBankBranch("");
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };

  const handleSubmitBankDetails = (e) => {
    e.preventDefault();
    if (bankAccountNumber !== confirmBankAccountNumber) {
      toast.error("Bank Account Number and Confirm Bank Account Number should be same");
    }

    else {
      setOpen(true);
      axios
        .post(url + "/coapplicant/addbank", {
          token: token,
          email: email,
          coapplicant_bank_ifsc: bankIfscCode,
          coapplicant_bank_name: bankName,
          coapplicant_bank_branch: bankBranch,
          coapplicant_bank_type: bankType,
          coapplicant_bank_account: bankAccountNumber,
          coapplicant_beneficiary_name: beneficiaryName,
          coapplicant_id: coapplicantId,
          coapplicant_borrower_uniqueno: coapplicantBorrowerUniqueNo,
        })
        .then((res) => {
          if (res.data.auth === true) {
            // console.log(res);
            setOpen(false);
            toast.success(res.data.message);
          } else {
            // console.log(res.data.message);

            setOpen(false);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err);

          setOpen(false);
          toast.error(err.message);
        });
    }
  };

  const checkLeadDate = () => {
    const targetDate = new Date("2024-09-16T00:00:00Z");
    const createdDate = new Date(coapplicantCreatedDate);

    if (createdDate < targetDate) {
      setDisableInputField(false);
    } else {
      setDisableInputField(true);
    }
  };
  const handlePrimaryBusinessCheckbox = (e) => {
    console.log(e.target.checked)
    setprimaryBusinessChecked(e.target.checked);
    if (e.target.checked === true) {
      setprimaryCoapplicantBusinessAddress(coapplicantAddress);
      setprimaryCoapplicantBusinessPincode(coapplicantPincode);
      setprimaryCoapplicantBusinessState(coapplicantState);
      setprimaryCoapplicantBusinessCity(coapplicantCity);
      setprimaryCoapplicantBusinessLandmark(coapplicantLandmark);
      setprimaryCoapplicantBusinessLocality(coapplicantLocality);
      setprimaryCoapplicantBusinessSubDist(coapplicantSubDist);
      setprimaryCoapplicantBusinessLocalityArr(coapplicantLocalityArr);
      setprimaryCoapplicantBusinessSubDistArr(coapplicantSubDistArr);
    }
  };
  useEffect(() => {
    if (coapplicantCreatedDate) {
      checkLeadDate();
    }
    // eslint-disable-next-line
  }, [coapplicantCreatedDate]);

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h2 className="main-heading">
              <GroupAddIcon />
              Edit Co-applicant
            </h2>
            <div className="inner-content-container">
              <Accordion className="accordian-coapp" sx={accordianSX}>
                <AccordionSummary
                  sx={mainAccordian}
                  id="panel1-header"
                  aria-controls="panel1-content"
                  expandIcon={<ExpandMoreOutlined />}
                >
                  <h3 className="accordian-header">Co-applicant Details</h3>
                </AccordionSummary>
                <form action="" onSubmit={handleSubmitCoApplicantDetails}>
                  <AccordionDetails>
                    <div className="lms-reg-form">
                      <div className="input-div">
                        <label>Borrower Id</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          disabled
                          // select
                          variant="outlined"
                          id="borrower-unique-no"
                          name="borrower-unique-no"
                          value={coapplicantBorrowerUniqueNo}
                          onChange={handleSelectBorrower}
                        />
                      </div>
                      <div className="input-div">
                        <label>Select Loan Id*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          type="number"
                          select
                          disabled
                          value={coapplicantLoanId}
                          variant="outlined"
                          id="loan-num"
                          onChange={(e) => setCoapplicantLoanId(e.target.value)}
                          name="loan-num"
                        >
                          {data2?.map((data, id) => (
                            <MenuItem
                              key={id}
                              value={data}
                              selected={coapplicantLoanId}
                            >
                              {data}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label htmlFor="name">Name*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          variant="outlined"
                          id="name"
                          required
                          value={coapplicantName}
                          onChange={(e) => handleCoapplicantName(e)}
                          name="name"
                          disabled={disableInputField}
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="dob">Date Of Birth*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          type="date"
                          required
                          value={coapplicantDob}
                          variant="outlined"
                          id="dob"
                          onChange={(e) => setCoapplicantDob(e.target.value)}
                          name="dob"
                          disabled={disableInputField}
                        />
                      </div>
                      <div className="input-div">
                        <label>Gender*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          required
                          variant="outlined"
                          id="gender"
                          name="gender"
                          value={coapplicantGender}
                          onChange={(e) => setCoapplicantGender(e.target.value)}
                        // disabled= {disableInputField}
                        >
                          <MenuItem value="MALE">MALE</MenuItem>
                          <MenuItem value="FEMALE">FEMALE</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label htmlFor="ph-no">Phone No.</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          variant="outlined"
                          id="ph-no"
                          disabled
                          value={coapplicantPhoneNumber}
                          type="number"
                          onChange={handleChangeCoapplicantPhoneNumber}
                          name="ph-no"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="email">E-mail*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          required
                          variant="outlined"
                          value={coapplicantEmail}
                          type="email"
                          onChange={(e) => setCoapplicantEmail(e.target.value)}
                        />
                      </div>
                      <div className="input-div">
                        <label>Maritial Status</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          variant="outlined"
                          // id="mar-status"
                          name="mar-status"
                          value={coapplicantMaritalStatus}
                          onChange={(e) =>
                            setCoapplicantMaritalStatus(e.target.value)
                          }
                        >
                          <MenuItem value="MARRIED">MARRIED</MenuItem>
                          <MenuItem value="SINGLE">SINGLE</MenuItem>
                          <MenuItem value="DIVORCEE">DIVORCEE</MenuItem>
                          <MenuItem value="WIDOW">WIDOW</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label>Education Qualification</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          variant="outlined"
                          // id="education"
                          name="education"
                          value={coapplicantEducationalQualification}
                          onChange={(e) =>
                            setCoapplicantEducationalQualification(
                              e.target.value
                            )
                          }
                        >
                          <MenuItem value="ILLITERATE">ILLITERATE</MenuItem>
                          <MenuItem value="10TH">10TH</MenuItem>
                          <MenuItem value="12TH">12TH</MenuItem>
                          <MenuItem value="GRADUATE">GRADUATE</MenuItem>
                          <MenuItem value="POST-GRADUATE">
                            POST-GRADUATE
                          </MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label>Residence Type</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          variant="outlined"
                          // id="res-type"
                          name="res-type"
                          value={coapplicantResidenceType}
                          onChange={(e) =>
                            setCoapplicantResidenceType(e.target.value)
                          }
                        >
                          <MenuItem value="RENTED">RENTED</MenuItem>
                          <MenuItem value="OWNED">OWNED</MenuItem>
                          <MenuItem value="PARENTAL">PARENTAL</MenuItem>
                          <MenuItem value="COMPANY PROVIDED">
                            COMPANY PROVIDED
                          </MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label htmlFor="address">Address</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          value={coapplicantAddress}
                          variant="outlined"
                          id="address"
                          onChange={(e) =>
                            setCoapplicantAddress(e.target.value)
                          }
                          name="address"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="sr-pincode">Search PIN Code</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          value={coapplicantPincode}
                          onChange={handleChangeSearchPincode}
                          variant="outlined"
                          id="sr-pincode"
                          name="sr-pincode"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="pincode">PIN Code</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          value={coapplicantPincode}
                          variant="outlined"
                          id="pincode"
                          onChange={(e) =>
                            setCoapplicantPincode(e.target.value)
                          }
                          disabled
                          name="pincode"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="state-name">State</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          value={coapplicantState}
                          disabled
                          variant="outlined"
                          id="state-name"
                          onChange={(e) => setCoapplicantState(e.target.value)}
                          name="state-name"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="city">City</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          value={coapplicantCity}
                          disabled
                          variant="outlined"
                          id="city"
                          onChange={(e) => setCoapplicantCity(e.target.value)}
                          name="city"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="city">Sub District</label>
                        <TextField
                          className="lms-input-field"
                          select
                          size="small"
                          value={coapplicantSubDist}
                          placeholder="Sub District"
                          variant="outlined"
                          id="city"
                          onChange={handleSubDistChange}
                          name="city"
                        >
                          {coapplicantSubDistArr?.map(subDistrict => {
                            return <MenuItem value={subDistrict} key={subDistrict}> {subDistrict}</MenuItem>
                          })}
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label htmlFor="city">Locality/Village</label>
                        <TextField
                          className="lms-input-field"
                          select
                          error={negativeArea}
                          helperText={negativeArea ? 'Negative Area' : ''}
                          size="small"
                          value={coapplicantLocality}
                          placeholder="Locality/Village"
                          variant="outlined"
                          id="city"
                          onChange={(e) => checkNegativeArea(e.target.value)}
                          name="city"
                        >
                          {coapplicantLocalityArr?.map(locality => {
                            return <MenuItem key={locality} value={locality}>{locality}</MenuItem>
                          })}
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label>Landmark</label>
                        <TextField
                          className="lms-input-field"
                          name="perm-landmark"
                          value={coapplicantLandmark}
                          placeholder="Landmark"
                          onChange={(e) =>
                            setcoapplicantLandmark(e.target.value)
                          }
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="rel-with-applicant">
                          Relationship with Applicant
                        </label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          value={coapplicantRelationship}
                          variant="outlined"
                          id="rel-with-applicant"
                          onChange={(e) =>
                            setCoapplicantRelationship(e.target.value)
                          }
                          name="rel-with-applicant"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="fathers-name">Father's Name</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          value={coapplicantFatherName}
                          variant="outlined"
                          id="fathers-name"
                          onChange={(e) => handlefatherName(e)}
                          name="fathers-name"
                        />
                      </div>

                      <div className="input-div">
                        <label>Type Of Profession</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          variant="outlined"
                          // id="profession"
                          name="profession"
                          value={coapplicantProfession}
                          onChange={(e) =>
                            setCoapplicantProfession(e.target.value)
                          }
                        >
                          <MenuItem value="SALARIED">SALARIED</MenuItem>
                          <MenuItem value="SELF-EMPLOYED">
                            SELF-EMPLOYED
                          </MenuItem>
                          <MenuItem value="HOUSEWIFE">HOUSEWIFE</MenuItem>
                          <MenuItem value="STUDENT">STUDENT</MenuItem>
                          <MenuItem value="RETIRED">RETIRED</MenuItem>
                        </TextField>
                      </div>

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Checkbox checked={coapplicant_compute_income} onChange={handleChangeComputeIncome} />
                        <label htmlFor="monthly-income">Is Co-applicant income is computed?</label>
                      </div>
                      <div className="input-div">
                        <label>Mother’s Maiden name*</label>
                        <TextField
                          className="lms-input-field"
                          value={motherMaiden}
                          name="number-of-active-loans"
                          onChange={(e) => setmotherMaiden(e.target.value)}
                          placeholder="Mother’s Maiden Name"
                          size="small"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="monthly-income">Mother Tongue</label>
                        <TextField
                          className="lms-input-field"
                          select
                          size="small"
                          placeholder="Mother Tongue"
                          value={coapplicant_mothertongue}
                          variant="outlined"
                          id="monthly-income"
                          onChange={(e) =>
                            setcoapplicant_mothertongue(e.target.value)
                          }
                          name="monthly-income"
                        >
                          <MenuItem value="HINDI">Hindi</MenuItem>
                          <MenuItem value="GUJARATI">
                            Gujarati
                          </MenuItem>
                          <MenuItem value="ENGLISH">
                            English
                          </MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label htmlFor="monthly-income">Category</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          placeholder="Category"
                          value={coapplicant_category}
                          variant="outlined"
                          id="monthly-income"
                          onChange={(e) =>
                            setcoapplicant_category(e.target.value)
                          }
                          name="monthly-income"
                        >
                          <MenuItem value="GENERAL">GENERAL</MenuItem>
                          <MenuItem value="SC">
                            SC
                          </MenuItem>
                          <MenuItem value="ST">
                            ST
                          </MenuItem>
                          <MenuItem value="OBC">
                            OBC
                          </MenuItem>
                          <MenuItem value="OTHER">
                            OTHER
                          </MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label htmlFor="monthly-income">Religion</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          placeholder="Religion"
                          value={coapplicant_religion}
                          variant="outlined"
                          id="monthly-income"
                          onChange={(e) =>
                            setcoapplicant_religion(e.target.value)
                          }
                          name="monthly-income"
                        >
                          <MenuItem value="HINDU">Hindu</MenuItem>
                          <MenuItem value="MUSLIM">
                            Muslim
                          </MenuItem>
                          <MenuItem value="SIKH">Sikh</MenuItem>
                          <MenuItem value="CHRISTIAN">Christian</MenuItem>
                          <MenuItem value="JAIN">Jain</MenuItem>
                          <MenuItem value="BUDDHISM">Buddhism</MenuItem>
                        </TextField>
                      </div>
                      {coapplicantMaritalStatus === "MARRIED" ? (
                        <div className="input-div">
                          <label htmlFor="monthly-income">Date Of Marriage</label>
                          <TextField
                            className="lms-input-field"
                            size="small"
                            type="date"
                            placeholder="Date Of Marriage"
                            value={coapplicant_dateofmarriage ? coapplicant_dateofmarriage.slice(0, 10) : ""}
                            variant="outlined"
                            id="monthly-income"
                            onChange={(e) =>
                              setcoapplicant_dateofmarriage(e.target.value)
                            }
                            name="monthly-income"
                            inputProps={{
                              max: new Date().toISOString().split("T")[0],
                            }}
                          />
                        </div>
                      ) : ""}
                      <div className="input-div">
                        <label htmlFor="monthly-income">Family Structure</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          select
                          placeholder="Family Structure"
                          value={coapplicant_familystructure}
                          variant="outlined"
                          id="monthly-income"
                          onChange={(e) =>
                            setcoapplicant_familystructure(e.target.value)
                          }
                          name="monthly-income"
                        >
                          <MenuItem value="JOINTLY WITH PARENTS">Jointly with Parents</MenuItem>
                          <MenuItem value="JOINTLY WITH RELATIVES">
                            Jointly with Relatives
                          </MenuItem>
                          <MenuItem value="NUCLEAR">Nuclear</MenuItem>
                        </TextField>
                      </div>
                      <div className="input-div">
                        <label>Total Family Members*</label>
                        <TextField
                          className="input-field"
                          type="number"
                          name="last-name"
                          onChange={(e) => settotalFamilyMembers(e.target.value)}
                          value={totalFamilyMembers}
                          placeholder="Total Family Members"
                          size="small"
                        />
                      </div>

                      <div className="input-div">
                        <label htmlFor="pan-no">Pan Number* </label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          placeholder="Pan Number"
                          value={coapplicantPanNo}
                          variant="outlined"
                          id="pan-no"
                          disabled
                          name="pan-no"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="aadhaar-number">Aadhaar Number*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          placeholder="Aadhar Number"
                          value={coapplicantAadhaarNo}
                          variant="outlined"
                          id="aadhaar-number"
                          disabled
                          name="aadhaar-number"
                        />
                      </div>
                      <div className="input-div">
                        <label htmlFor="voter-id">Voter Id*</label>
                        <TextField
                          className="lms-input-field"
                          size="small"
                          placeholder="Voter Id"
                          value={coapplicantVoterId}
                          variant="outlined"
                          id="voter-id"
                          name="voter-id"
                          onChange={(e) => setCoapplicantVoterId(e.target.value)}
                          disabled={!voterIdEditable}
                        />
                      </div>
                      <div className="input-div">
                        <label>Residing at Current Address Since*(In Years)</label>
                        <TextField
                          className="input-field"
                          value={residingSince}
                          type="number"
                          name="number-of-active-loans"
                          onChange={(e) => setresidingSince(e.target.value)}
                          placeholder="Residing at Current Address Since"
                          size="small"
                        />
                      </div>
                      <Dialog open={openDialog}>
                        <DialogTitle>Choose KYC Option to proceed</DialogTitle>
                        <DialogContent sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Button variant="contained" sx={{ margin: '0.5rem' }} onClick={() => handleChoice('eKyc')}>e-Kyc</Button>
                          <Button variant="contained" sx={{ margin: '0.5rem' }} onClick={() => handleChoice('Physical')}>Physical KYC</Button>
                        </DialogContent>
                      </Dialog>
                    </div>
                  </AccordionDetails>
                  <div className="btns-add-borrower">
                    <Button
                      variant="contained"
                      color="success"
                      type="submit"
                      style={{ marginRight: "1rem" }}
                    >
                      Update
                    </Button>
                  </div>
                </form>
              </Accordion>

              <Accordion className="menu-item-add-borrower">
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <h3 className="accordian-header">
                    Bank Details
                  </h3>
                </AccordionSummary>
                <form action="" onSubmit={handleSubmitBankDetails}>
                  <AccordionDetails className="bank-details">
                    <div className="input-item">
                      <label>Bank Search by IFSC*</label>
                      <br />
                      <TextField
                        className="input-field"
                        value={bankIfscCode}
                        name="collection-bank-ifsc-code"
                        onChange={handleChangeCollectionBankIfscCode}
                        placeholder="Bank IFSC Code"
                        size="small"
                      />
                    </div>
                    <div className="input-item">
                      <label>Bank Name*</label>
                      <br />
                      <TextField
                        className="input-field"
                        value={bankName}
                        disabled
                        onChange={(e) =>
                          setBankName(e.target.value)
                        }
                        name="collection-bank-name"
                        placeholder="Bank Name"
                        size="small"
                      ></TextField>
                    </div>
                    <div className="input-item">
                      <label>Bank Branch*</label>
                      <br />
                      <TextField
                        className="input-field"
                        value={bankBranch}
                        disabled
                        onChange={(e) =>
                          setBankBranch(e.target.value)
                        }
                        name="collection-bank-branch"
                        placeholder="Bank Branch"
                        size="small"
                      />
                    </div>

                    <div className="input-item">
                      <label>Bank type*</label>
                      <br />
                      <TextField
                        className="input-field"
                        select
                        name="collection-bank-type"
                        value={bankType}
                        size="small"
                        onChange={(e) =>
                          setBankType(e.target.value)
                        }
                      >
                        <MenuItem value="SAVINGS">SAVINGS</MenuItem>
                        <MenuItem value="CURRENT">CURRENT</MenuItem>
                        <MenuItem value="CC/OD">CC/OD</MenuItem>
                      </TextField>
                    </div>
                    <div className="input-item">
                      <label>Bank Account Number*</label>
                      <br />
                      <TextField
                        className="input-field"
                        value={bankAccountNumber}
                        name="collection-bank-account"
                        onChange={(e) =>
                          setBankAccountNumber(e.target.value)
                        }
                        placeholder="Bank Account Number"
                        size="small"
                      />
                    </div>

                    <div className="input-item">
                      <label>Confirm Bank Account Number*</label>
                      <br />
                      <TextField
                        className="input-field"
                        value={confirmBankAccountNumber}
                        name="collection-bank-account"
                        onChange={(e) =>
                          setconfirmBankAccountNumber(e.target.value)
                        }
                        placeholder="Confirm Bank Account Number"
                        size="small"
                      />
                    </div>

                    <div className="input-item">
                      <label>Beneficiary Name*</label>
                      <br />
                      <TextField
                        className="input-field"
                        value={beneficiaryName}
                        onChange={(e) =>
                          setBeneficiaryName(e.target.value)
                        }
                        name="collection-beneficiary-name"
                        placeholder="Beneficiary Name"
                        size="small"
                      />
                    </div>
                  </AccordionDetails>
                  <div className="btns-add-borrower">
                    <Button
                      variant="contained"
                      color="success"
                      type="submit"
                      style={{ marginRight: "1rem" }}
                    >
                      Update
                    </Button>
                  </div>
                </form>
              </Accordion>

              {(coapplicantProfession === "SALARIED" || coapplicantProfession === "SELF-EMPLOYED") ? (
                <Accordion className="menu-item-add-borrower">
                  <AccordionSummary
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <h3 className="accordian-header">
                      Primary Occupation Details
                    </h3>
                  </AccordionSummary>
                  <form action="" onSubmit={handlePrimaryBusinessDetails}>
                    <AccordionDetails>
                      {coapplicantProfession === "SALARIED" ? (
                        <div>
                          <div className="bank-details">
                            <div className="input-item">
                              <label>Nature of Business</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="nature-of-business"
                                value={businessNature}
                                size="small"
                                onChange={(e) =>
                                  setBusinessNature(e.target.value)
                                }
                              >
                                {natureOfBusinessArray.map(
                                  (businessNature, i) => (
                                    <MenuItem
                                      key={i}
                                      value={natureOfBusinessArray[i]}
                                    >
                                      {businessNature}
                                    </MenuItem>
                                  )
                                )}
                              </TextField>
                            </div>

                            <div className="input-item">
                              <label>Company Type</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={companyType}
                                name="employer-name"
                                onChange={(e) =>
                                  setCompanyType(e.target.value)
                                }
                                placeholder="Company Type"
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Designation Name</label>
                              <br />
                              <input
                                type="text"
                                className="input-field"
                                value={designationName}
                                name="designation-name"
                                onChange={(e) =>
                                  setDesignationName(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                            <div className="input-item">
                              <label>Variable  Incentive</label>
                              <br />
                              <input
                                type="text"
                                className="input-field"
                                value={Variable_Incentive}
                                name="designation-name"
                                onChange={(e) =>
                                  setVariable_Incentive(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                              <div className="input-item">
                              <label>Other Allowances</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={Other_Allowances}
                                name="designation-name"
                                onChange={(e) =>
                                  setOther_Allowances(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                              <div className="input-item">
                              <label>Gross Monthly Salary</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={Gross_Monthly_Salary}
                                name="designation-name"
                                onChange={(e) =>
                                  setGross_Monthly_Salary(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                              <div className="input-item">
                              <label>Fixed Salary</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={Fixed_Salary}
                                name="designation-name"
                                onChange={(e) =>
                                  setFixed_Salary(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                             <div className="input-item">
                              <label>Basic Salary</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={Basic_Salary}
                                name="Basic-Salary"
                                onChange={(e) =>
                                  setBasic_Salary(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                            <div className="input-item">
                              <label>H R A Salary</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={HRA_Salary}
                                name="HRA-Salary"
                                onChange={(e) =>
                                  setHRA_Salary(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                            <div className="input-item">
                              <label>PF Salary</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={PF_Salary}
                                name="PF"
                                onChange={(e) =>
                                  setPF_Salary(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                            <div className="input-item">
                              <label>ESIC Salary</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={ESIC_Salary}
                                name="ESIC-Salary"
                                onChange={(e) =>
                                  setESIC_Salary(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                              <div className="input-item">
                              <label>Other Dedutions Salary</label>
                              <br />
                              <input
                                type="number"
                                className="input-field"
                                value={Other_Dedutions_Salary}
                                name="Other_Dedutions_Salary"
                                onChange={(e) =>
                                  setOther_Dedutions_Salary(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>
                          <div className="input-item">
                              <label>Employer Name</label>
                              <br />
                              <input
                                type="text"
                                className="input-field"
                                value={EmployerName}
                                name="designation-name"
                                onChange={(e) =>
                                  setEmployerName(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>     <div className="input-item">
                              <label>Industry</label>
                              <br />
                              <input
                                type="test"
                                className="input-field"
                                value={Industry}
                                name="designation-name"
                                onChange={(e) =>
                                  setIndustry(e.target.value)
                                }
                                // placeholder="Designation Name"
                                style={{
                                  height: "2.5rem",
                                  borderRadius: "5px",
                                  border: "1px solid lightgray",
                                }}
                              />
                            </div>   
                            
                            
                            
                            <div className="input-item">
                              <label>
                                Duration with Current Employer (In Months)
                              </label>
                              <br />
                              <TextField
                                className="input-field"
                                value={durationWithCurrentEmployer}
                                name="duration-with-current-employer"
                                onChange={(e) =>
                                  setDurationWithCurrentEmployer(e.target.value)
                                }
                                placeholder="Duration with Current Employer (In Months)"
                                size="small"
                                type="number"
                              />
                            </div>

                            <div className="input-item">
                              <label>Salary Mode</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="salary-mode"
                                value={salaryMode}
                                size="small"
                                onChange={(e) => setSalaryMode(e.target.value)}
                              >
                                <MenuItem value="CASH">Cash</MenuItem>
                                <MenuItem value="CHEQUE">Cheque</MenuItem>
                                <MenuItem value="BANK TRANSFER">
                                  Bank Transfer
                                </MenuItem>
                              </TextField>
                            </div>
                            <div className="input-item">
                              <label>Current Salary Income(Monthly)</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={currentSalary}
                                name="current-salary"
                                onChange={(e) => setCurrentSalary(e.target.value)}
                                placeholder="Current Salary"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Previous Salary</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={prevSalary}
                                name="previous-salary"
                                onChange={(e) => setPrevSalary(e.target.value)}
                                placeholder="Previous Salary"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Total Work Experience (In Months)*</label>
                              <TextField
                                className="input-field"
                                value={totalWorkExperience}
                                name="previous-salary"
                                onChange={(e) => setTotalWorkExperience(e.target.value)}
                                placeholder="Total Work Experience (In Months)"
                                size="small"
                                type="number"
                              />
                            </div>
                              <div className="input-item">
                              <label>Work Location</label>
                              <TextField
                                className="input-field"
                                value={Work_Location}
                                name="previous-salary"
                                onChange={(e) => setWork_Location(e.target.value)}
                                // placeholder="Total Work Experience (In Months)"
                                size="small"
                                type="text"
                              />
                            </div>
                              <div className="input-item">
                              <label>Pan of Employer</label>
                              <TextField
                                className="input-field"
                                value={Pan_of_Employer}
                                name="previous-salary"
                                onChange={(e) => setPan_of_Employer(e.target.value)}
                                // placeholder="Total Work Experience (In Months)"
                                size="small"
                                type="text"
                              />
                            </div>
                            <div className="input-item">
                              <label>Office Number</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={officeNumber}
                                name="office-number"
                                onChange={(e) => setOfficeNumber(e.target.value)}
                                placeholder="Office Number"
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Office HR Number</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={officeHrNumber}
                                name="office-hr-number"
                                onChange={(e) =>
                                  setOfficeHrNumber(e.target.value)
                                }
                                placeholder="Office HR Number"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Department</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={department}
                                name="office-hr-number"
                                onChange={(e) =>
                                  setdepartment(e.target.value)
                                }
                                placeholder="Department"
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Employee Code</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={employeeCode}
                                name="office-hr-number"
                                onChange={(e) =>
                                  setemployeeCode(e.target.value)
                                }
                                placeholder="Employee Code"
                                size="small"
                                type="number"
                              />
                            </div>
                            <div className="input-item">
                              <label>Date of Joining</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={primaryJoining}
                                type="date"
                                name="office-hr-number"
                                onChange={(e) =>
                                  setprimaryJoining(e.target.value)
                                }
                                placeholder="Date of Joining"
                                size="small"
                                inputProps={{
                                  max: new Date().toISOString().split("T")[0],
                                }}
                              />
                            </div>
                            <div className="input-item">
                              <label>Official Email ID</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={primarySalariedofficialEmail}
                                type="email"
                                name="office-hr-number"
                                onChange={(e) =>
                                  setprimarySalariedofficialEmail(e.target.value)
                                }
                                placeholder="Official Email ID"
                                size="small"
                              />
                            </div>
                          </div>
                          <h3>Company Address</h3>
                          <br />
                          <div className="primary-business-address">
                            <div className="input-div">
                              <label htmlFor="address">Address</label>
                              <TextField
                                className="lms-input-field"
                                size="small"
                                value={primaryCoapplicantCompanyAddress}
                                variant="outlined"
                                placeholder="Coapplicant Address"
                                id="address"
                                onChange={(e) =>
                                  setprimaryCoapplicantCompanyAddress(e.target.value)
                                }
                                name="address"
                              />
                            </div>
                            <div className="input-div">
                              <label htmlFor="sr-pincode">Search PIN Code*</label>
                              <TextField
                                className="lms-input-field"
                                size="small"
                                placeholder="Search PIN Code"
                                value={primaryCoapplicantCompanyPincode}
                                onChange={handlePrimaryCompanyPincode}
                                variant="outlined"
                                id="sr-pincode"
                                name="sr-pincode"
                              />
                            </div>
                            <div className="input-div">
                              <label htmlFor="pincode">PIN Code</label>
                              <TextField
                                className="lms-input-field"
                                size="small"
                                value={primaryCoapplicantCompanyPincode}
                                placeholder="PIN Code"
                                variant="outlined"
                                id="pincode"
                                onChange={(e) =>
                                  setprimaryCoapplicantCompanyPincode(e.target.value)
                                }
                                disabled
                                name="pincode"
                              />
                            </div>
                            <div className="input-div">
                              <label htmlFor="state-name">State*</label>
                              <TextField
                                className="lms-input-field"
                                size="small"
                                value={primaryCoapplicantCompanyState}
                                disabled
                                placeholder="State"
                                variant="outlined"
                                id="state-name"
                                onChange={(e) => setprimaryCoapplicantCompanyState(e.target.value)}
                                name="state-name"
                              />
                            </div>
                            <div className="input-div">
                              <label htmlFor="city">City*</label>
                              <TextField
                                className="lms-input-field"
                                size="small"
                                value={primaryCoapplicantCompanyCity}
                                disabled
                                placeholder="City"
                                variant="outlined"
                                id="city"
                                onChange={(e) => setprimaryCoapplicantCompanyCity(e.target.value)}
                                name="city"
                              />
                            </div>
                            <div className="input-div">
                              <label htmlFor="city">Sub District*</label>
                              <TextField
                                className="lms-input-field"
                                select
                                size="small"
                                value={primaryCoapplicantCompanySubDist}
                                placeholder="Sub District"
                                variant="outlined"
                                id="city"
                                onChange={handleSubDistPrimaryCompanyChange}
                                name="city"
                              >
                                {primaryCoapplicantCompanySubDistArr?.map(subDistrict => {
                                  return <MenuItem value={subDistrict} key={subDistrict}> {subDistrict}</MenuItem>
                                })}
                              </TextField>
                            </div>
                            <div className="input-div">
                              <label htmlFor="city">Locality/Village*</label>
                              <TextField
                                className="lms-input-field"
                                select
                                error={negativeAreaCompanyPrimary}
                                helperText={negativeAreaCompanyPrimary ? 'Negative Area' : ''}
                                size="small"
                                value={primaryCoapplicantCompanyLocality}
                                placeholder="Locality/Village"
                                variant="outlined"
                                id="city"
                                onChange={(e) => checkNegativePrimaryCompanyArea(e.target.value, setprimaryCoapplicantCompanyLocality, 'CompanyLocality')}
                                name="city"
                              >
                                {primaryCoapplicantCompanyLocalityArr?.map(locality => {
                                  return <MenuItem key={locality} value={locality}>{locality}</MenuItem>
                                })}
                              </TextField>
                            </div>

                            <div className="input-div">
                              <label>Landmark</label>
                              <TextField
                                className="lms-input-field"
                                value={primaryCoapplicantCompanyLandmark}
                                name="officialLandmark"
                                onChange={(e) =>
                                  setprimaryCoapplicantCompanyLandmark(e.target.value)
                                }
                                placeholder="Landmark"
                                size="small"
                              />
                            </div>
                          </div>
                        </div>
                      ) : ""}
                      {coapplicantProfession === "SELF-EMPLOYED" ? (
                        <>
                          <div className="bank-details">

                            <div className="input-item">
                              <label>Loan Type*</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                name="type-of-loan"
                                value={typeOfLoan}
                                size="small"
                                onChange={(e) =>
                                  setTypeOfLoan(e.target.value)
                                }
                              >
                                <MenuItem value="CATTLE LOAN">Cattle Loan</MenuItem>
                                <MenuItem value="MSME LOAN">MSME Loan</MenuItem>
                              </TextField>
                            </div>
                            <br />
                            {typeOfLoan === "CATTLE LOAN" ? (
                              <>
                                <div className="input-item">
                                  <label>Business Type*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    name="type-of-business"
                                    value={typeOfBusiness}
                                    size="small"
                                    onChange={(e) =>
                                      setTypeOfBusiness(e.target.value)
                                    }
                                  >
                                    <MenuItem value="DAIRY-OPENMARKET">Dairy (OPEN MARKET)</MenuItem>
                                    <MenuItem value="DAIRY">Dairy (CO-OPERATIVE)</MenuItem>
                                    <MenuItem value="DAIRY-PRIVATE">Dairy (PRIVATE)</MenuItem>
                                    
                                  </TextField>
                                </div>
                                {typeOfBusiness !== 'DAIRY' ?
                                  (<div className="input-item">
                                    <label>Business Name*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={businessName}
                                      name="business-name"
                                      onChange={(e) => handlebusinessName(e)}
                                      placeholder="Business Name"
                                      size="small"
                                    />
                                  </div>) : (<div className="input-item">
                                    <label>Mandli Name</label>
                                    <Autocomplete
                                      value={businessName}
                                      disablePortal
                                      id="combo-box-demo"
                                      options={mandliArr}
                                      size="small"
                                      onChange={handleMandliChange}
                                      sx={{ width: '36vw' }}
                                      renderInput={(params) => <TextField {...params} onChange={mandliSuggestions} />}
                                    />
                                  </div>
                                  )}

                                {typeOfBusiness === "DAIRY" ?
                                  <>
                                    <div className="input-item">
                                      <label>Mantri Name*</label>
                                      <br />
                                      <TextField
                                        className="input-field"
                                        value={MantriName}
                                        name="income"
                                        onChange={(e) =>
                                          setMantriName(e.target.value)
                                        }
                                        placeholder="Mantri Name"
                                        size="small"
                                      />
                                    </div>
                                    <div className="input-item">
                                      <label>Mantri Number*</label>
                                      <br />
                                      <TextField
                                        className="input-field"
                                        value={MantriNumber}
                                        name="income"
                                        onChange={(e) =>
                                          setMantriNumber(e.target.value)
                                        }
                                        placeholder="Mantri Number"
                                        size="small"
                                      />
                                    </div>
                                  </>
                                  : ""}
                                <div className="input-item">
                                  <label>Income Mode*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    name="salary-mode"
                                    value={incomeMode}
                                    size="small"
                                    onChange={(e) => setIncomeMode(e.target.value)}
                                  >
                                    <MenuItem value="CASH">Cash</MenuItem>
                                    <MenuItem value="Cash+Bank">Cash+Bank</MenuItem>
                                    <MenuItem value="BANK TRANSFER">
                                      Bank Transfer
                                    </MenuItem>
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Business Income(Monthly)*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={businessIncome}
                                    name="income"
                                    onChange={(e) =>
                                      setBusinessIncome(e.target.value)
                                    }
                                    placeholder="Business Income(Monthly)"
                                    size="small"
                                  />
                                </div>

                                <div className="input-item">
                                  <label>Business Vintage (Months)*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={businessVintage}
                                    name="income"
                                    onChange={(e) =>
                                      setbusinessVintage(e.target.value)
                                    }
                                    placeholder="Business Vintage (Months)"
                                    size="small"
                                  />
                                </div>

                                <div className="input-item">
                                  <label>Legal Status</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value="PROPRIETORSHIP"
                                    name="legal-status"
                                    size="small"
                                    disabled
                                  />
                                </div>

                                <div className="input-item">
                                  <label>Business IDs</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value="Milk Statement"
                                    name="official-address"
                                    size="small"
                                    disabled
                                  />
                                </div>
                                <br />
                                <div className="input-item">
                                  <input
                                    type="checkbox"
                                    checked={primaryBusinessChecked}
                                    onChange={(e) => handlePrimaryBusinessCheckbox(e)}
                                    style={{ margin: "1rem 0" }}
                                  ></input>
                                  <label>  Same as Current Residence Address </label>

                                </div>
                                <br />
                                <h3>Business Address</h3>
                                <br></br>

                                <div className="input-div">
                                  <label htmlFor="address">Address*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessAddress}
                                    variant="outlined"
                                    placeholder="Coapplicant Address"
                                    id="address"
                                    onChange={(e) =>
                                      setprimaryCoapplicantBusinessAddress(e.target.value)
                                    }
                                    name="address"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="sr-pincode">Search PIN Code*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    // required
                                    placeholder="Search PIN Code"
                                    value={primaryCoapplicantBusinessPincode}
                                    onChange={handlePrimaryBusinessPincode}
                                    variant="outlined"
                                    id="sr-pincode"
                                    name="sr-pincode"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="pincode">PIN Code*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessPincode}
                                    placeholder="PIN Code"
                                    variant="outlined"
                                    id="pincode"
                                    onChange={(e) =>
                                      setprimaryCoapplicantBusinessPincode(e.target.value)
                                    }
                                    disabled
                                    name="pincode"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="state-name">State*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessState}
                                    disabled
                                    placeholder="State"
                                    variant="outlined"
                                    id="state-name"
                                    onChange={(e) => setprimaryCoapplicantBusinessState(e.target.value)}
                                    name="state-name"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="city">City*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessCity}
                                    disabled
                                    placeholder="City"
                                    variant="outlined"
                                    id="city"
                                    onChange={(e) => setprimaryCoapplicantBusinessCity(e.target.value)}
                                    name="city"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="city">Sub District*</label>
                                  <TextField
                                    className="lms-input-field"
                                    select
                                    size="small"
                                    value={primaryCoapplicantBusinessSubDist}
                                    placeholder="Sub District"
                                    variant="outlined"
                                    id="city"
                                    onChange={handleSubDistPrimaryBusinessChange}
                                    name="city"
                                  >
                                    {primaryCoapplicantBusinessSubDistArr?.map(subDistrict => {
                                      return <MenuItem value={subDistrict} key={subDistrict}> {subDistrict}</MenuItem>
                                    })}
                                  </TextField>
                                </div>
                                <div className="input-div">
                                  <label htmlFor="city">Locality/Village*</label>
                                  <TextField
                                    className="lms-input-field"
                                    select
                                    error={negativeAreaBusinessPrimary}
                                    helperText={negativeAreaBusinessPrimary ? 'Negative Area' : ''}
                                    size="small"
                                    value={primaryCoapplicantBusinessLocality}
                                    placeholder="Locality/Village"
                                    variant="outlined"
                                    id="city"
                                    onChange={(e) => checkNegativePrimaryBusinessArea(e.target.value)}
                                    name="city"
                                  >
                                    {primaryCoapplicantBusinessLocalityArr?.map(locality => {
                                      return <MenuItem key={locality} value={locality}>{locality}</MenuItem>
                                    })}
                                  </TextField>
                                </div>

                                <div className="input-div">
                                  <label>Landmark</label>
                                  <TextField
                                    className="lms-input-field"
                                    value={primaryCoapplicantBusinessLandmark}
                                    name="official-landmark"
                                    onChange={(e) =>
                                      setprimaryCoapplicantBusinessLandmark(e.target.value)
                                    }
                                    placeholder="Landmark"
                                    size="small"
                                  />
                                </div>


                              </>
                            ) : ""}

                            {typeOfLoan === "MSME LOAN" ? (
                              <>
                                <div className="input-item">
                                  <label>Business Type*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    name="type-of-business"
                                    value={typeOfBusiness}
                                    size="small"
                                    onChange={(e) =>
                                      setTypeOfBusiness(e.target.value)
                                    }
                                  >
                                    <MenuItem value="GROCERY">Grocery</MenuItem>
                                    <MenuItem value="VEGETABLE">Vegetable</MenuItem>
                                    <MenuItem value="MEDICAL">Medical</MenuItem>
                                    <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                                    <MenuItem value="Trading">Trading</MenuItem>
                                    <MenuItem value="Agriculture">Agriculture</MenuItem>
                                    <MenuItem value="Services">Services</MenuItem>
                                    <MenuItem value="Flour Mill">Flour Mill</MenuItem>
                                    <MenuItem value="Diagnostic Centre (cattle/human)">Diagnostic Centre (cattle/human)</MenuItem>
                                  </TextField>
                                </div>
                                {typeOfBusiness !== 'DAIRY' ?
                                  (<div className="input-item">
                                    <label>Business Name*</label>
                                    <br />
                                    <TextField
                                      className="input-field"
                                      value={businessName}
                                      name="business-name"
                                      onChange={(e) => handlebusinessName(e)}
                                      placeholder="Business Name"
                                      size="small"
                                    />
                                  </div>) : (<div className="input-item">
                                    <label>Mandli Name</label>
                                    <Autocomplete
                                      value={businessName}
                                      disablePortal
                                      id="combo-box-demo"
                                      options={mandliArr}
                                      size="small"
                                      onChange={handleMandliChange}
                                      sx={{ width: '36vw' }}
                                      renderInput={(params) => <TextField {...params} onChange={mandliSuggestions} />}
                                    />
                                  </div>
                                  )}

                                <div className="input-item">
                                  <label>Income Mode*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    select
                                    name="salary-mode"
                                    value={incomeMode}
                                    size="small"
                                    onChange={(e) => setIncomeMode(e.target.value)}
                                  >
                                    <MenuItem value="CASH">Cash</MenuItem>
                                    <MenuItem value="Cash+Bank">Cash+Bank</MenuItem>
                                    <MenuItem value="BANK TRANSFER">
                                      Bank Transfer
                                    </MenuItem>
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Business Income(Monthly)*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={businessIncome}
                                    name="income"
                                    onChange={(e) =>
                                      setBusinessIncome(e.target.value)
                                    }
                                    placeholder="Business Income(Monthly)"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Business Email ID*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={primarySelfEmployeedofficialEmail}
                                    type="email"
                                    name="office-hr-number"
                                    onChange={(e) =>
                                      setprimarySelfEmployeedofficialEmail(e.target.value)
                                    }
                                    placeholder="Business Email ID"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Business Phone Number*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={primarySelfEmployeedofficialPhoneNumber}
                                    type="number"
                                    name="office-hr-number"
                                    onChange={(e) =>
                                      setprimarySelfEmployeedofficialPhoneNumber(e.target.value)
                                    }
                                    placeholder="Business Phone Number"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Business Vintage (Months)*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={businessVintage}
                                    name="income"
                                    onChange={(e) =>
                                      setbusinessVintage(e.target.value)
                                    }
                                    placeholder="Business Vintage (Months)"
                                    size="small"
                                  />
                                </div>

                                <div className="input-item">
                                  <label>If Professional*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={ifProfessional}
                                    name="official-address"
                                    onChange={(e) => setifProfessional(e.target.value)}
                                    placeholder="If Professional"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>If Business* </label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={ifbusiness}
                                    name="official-address"
                                    onChange={(e) => setifbusiness(e.target.value)}
                                    placeholder="If Business"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Legal Status</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={legalStatus}
                                    name="official-address"
                                    onChange={(e) => setlegalStatus(e.target.value)}
                                    placeholder="Legal Status"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Workplace</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={workplace}
                                    name="official-address"
                                    onChange={(e) => setworkplace(e.target.value)}
                                    placeholder="Workplace"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Workplace Size</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={workplaceSize}
                                    name="official-address"
                                    onChange={(e) => setworkplaceSize(e.target.value)}
                                    placeholder="Workplace Size"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Current Workplace Stability*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={workplaceStability}
                                    name="official-address"
                                    onChange={(e) => setworkplaceStability(e.target.value)}
                                    placeholder="Current Workplace Stability"
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Business IDs*</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={businessID}
                                    select
                                    name="total-work-experience"
                                    onChange={(e) =>
                                      setbusinessID(e.target.value)
                                    }
                                    placeholder="Business IDs"
                                    size="small"
                                    type="number"
                                  >
                                    <MenuItem value="UDHYAM">
                                      UDHYAM
                                    </MenuItem>
                                    <MenuItem value="GST">
                                      GST
                                    </MenuItem>
                                    <MenuItem value="SHOP & ESTABLISHMENT">
                                      SHOP & ESTABLISHMENT
                                    </MenuItem>
                                    <MenuItem value="GUMASTADARA">
                                      GUMASTADARA
                                    </MenuItem>
                                    <MenuItem value="PARTNERSHIP DEED">
                                      PARTNERSHIP DEED
                                    </MenuItem>
                                    <MenuItem value="COMPANY REGISTRATION (COI)">
                                      COMPANY REGISTRATION (COI)
                                    </MenuItem>
                                  </TextField>
                                </div>
                                <div className="input-item">
                                  <label>Number of Employees</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={numberOfEmployees}
                                    name="official-address"
                                    onChange={(e) => setnumberOfEmployees(e.target.value)}
                                    placeholder="Number of Employees"
                                    size="small"
                                  />
                                </div>
                                <br />
                                <div className="input-item">
                                  <input
                                    type="checkbox"
                                    checked={primaryBusinessChecked}
                                    onChange={(e) => handlePrimaryBusinessCheckbox(e)}
                                    style={{ margin: "1rem 0" }}
                                  ></input>
                                  <label>  Same as Current Residence Address </label>

                                </div>
                                <br />
                                <h3>Business Address</h3>
                                <br></br>

                                <div className="input-div">
                                  <label htmlFor="address">Address*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessAddress}
                                    variant="outlined"
                                    placeholder="Coapplicant Address"
                                    id="address"
                                    onChange={(e) =>
                                      setprimaryCoapplicantBusinessAddress(e.target.value)
                                    }
                                    name="address"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="sr-pincode">Search PIN Code*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    required
                                    placeholder="Search PIN Code"
                                    value={primaryCoapplicantBusinessPincode}
                                    onChange={handlePrimaryBusinessPincode}
                                    variant="outlined"
                                    id="sr-pincode"
                                    name="sr-pincode"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="pincode">PIN Code*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessPincode}
                                    placeholder="PIN Code"
                                    variant="outlined"
                                    id="pincode"
                                    onChange={(e) =>
                                      setprimaryCoapplicantBusinessPincode(e.target.value)
                                    }
                                    disabled
                                    name="pincode"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="state-name">State*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessState}
                                    disabled
                                    placeholder="State"
                                    variant="outlined"
                                    id="state-name"
                                    onChange={(e) => setprimaryCoapplicantBusinessState(e.target.value)}
                                    name="state-name"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="city">City*</label>
                                  <TextField
                                    className="lms-input-field"
                                    size="small"
                                    value={primaryCoapplicantBusinessCity}
                                    disabled
                                    placeholder="City"
                                    variant="outlined"
                                    id="city"
                                    onChange={(e) => setprimaryCoapplicantBusinessCity(e.target.value)}
                                    name="city"
                                  />
                                </div>
                                <div className="input-div">
                                  <label htmlFor="city">Sub District*</label>
                                  <TextField
                                    className="lms-input-field"
                                    select
                                    size="small"
                                    value={primaryCoapplicantBusinessSubDist}
                                    placeholder="Sub District"
                                    variant="outlined"
                                    id="city"
                                    onChange={handleSubDistPrimaryBusinessChange}
                                    name="city"
                                  >
                                    {primaryCoapplicantBusinessSubDistArr?.map(subDistrict => {
                                      return <MenuItem value={subDistrict} key={subDistrict}> {subDistrict}</MenuItem>
                                    })}
                                  </TextField>
                                </div>
                                <div className="input-div">
                                  <label htmlFor="city">Locality/Village*</label>
                                  <TextField
                                    className="lms-input-field"
                                    select
                                    error={negativeAreaBusinessPrimary}
                                    helperText={negativeAreaBusinessPrimary ? 'Negative Area' : ''}
                                    size="small"
                                    value={primaryCoapplicantBusinessLocality}
                                    placeholder="Locality/Village"
                                    variant="outlined"
                                    id="city"
                                    onChange={(e) => checkNegativePrimaryBusinessArea(e.target.value)}
                                    name="city"
                                  >
                                    {primaryCoapplicantBusinessLocalityArr?.map(locality => {
                                      return <MenuItem key={locality} value={locality}>{locality}</MenuItem>
                                    })}
                                  </TextField>
                                 </div>

                                <div className="input-div">
                                  <label>Landmark</label>
                                  <TextField
                                    className="lms-input-field"
                                    value={primaryCoapplicantBusinessLandmark}
                                    name="official-landmark"
                                    onChange={(e) =>
                                      setprimaryCoapplicantBusinessLandmark(e.target.value)
                                    }
                                    placeholder="Landmark"
                                    size="small"
                                  />
                                </div>


                              </>
                            ) : ""}
                          </div>
                        </>
                      ) : ""}
                    </AccordionDetails>
                    <div className="btns-add-borrower">
                      <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        style={{ marginRight: "1rem" }}
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Accordion>
              ) : ""}

              <Accordion className="menu-item-add-borrower">
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <h3 className="accordian-header" style={{ fontWeight: "bold" }}>
                    Surrogate Business Details
                  </h3>
                </AccordionSummary>
                <form action="" onSubmit={handleSurrogateDetails}>
                  <AccordionDetails>
                    {demoTypes.map((demoType, index) => (
                      <div key={index} className="input-item">
                        <label>Surrogate Profession Type</label>
                        <br />
                        <TextField
                          className="input-field"
                          select
                          name={`profession-type-${index}`}
                          value={demoType}
                          size="small"
                          sx={{ width: "40rem" }}
                          onChange={(e) => handleSurrogateProfession(index, e.target.value)}
                        >
                          <MenuItem value="SALARIED">SALARIED</MenuItem>
                          <MenuItem value="SELF-EMPLOYED">SELF-EMPLOYED</MenuItem>
                        </TextField>
                        <br />
                        {demoType === "SALARIED" ? (
                          <>
                            <div className="bank-details">
                              <div className="input-item">
                                <label>Nature of Business</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  value={formData[index]?.natureOfBusiness || ""}
                                  name={`nature-of-business-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'natureOfBusiness', e.target.value)}
                                  size="small"
                                >
                                  {natureOfBusinessArray.map(
                                    (businessNature, i) => (
                                      <MenuItem
                                        key={i}
                                        value={natureOfBusinessArray[i]}
                                      >
                                        {businessNature}
                                      </MenuItem>
                                    )
                                  )}
                                </TextField>
                              </div>
                              <div className="input-item">
                                <label>Designation Name</label>
                                <br />
                                <input
                                  type="text"
                                  className="input-field"
                                  value={formData[index]?.designationName || ""}
                                  name={`designation-name-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'designationName', e.target.value)}
                                  style={{
                                    height: "2.5rem",
                                    borderRadius: "5px",
                                    border: "1px solid lightgray",
                                  }}
                                />
                              </div>
                              <div className="input-item">
                                <label>
                                  Duration with Current Employer (In Months)
                                </label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.durationWithCurrentEmployer || ""}
                                  name={`duration-with-current-employer-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'durationWithCurrentEmployer', e.target.value)}
                                  size="small"
                                  type="number"
                                />
                              </div>
                              <div className="input-item">
                                <label>Salary Mode</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  size="small"
                                  name={`salary-mode-${index}`}
                                  value={formData[index]?.salaryMode || ""}
                                  onChange={(e) => handleSurrogateInputChange(index, 'salaryMode', e.target.value)}
                                >
                                  <MenuItem value="CASH">Cash</MenuItem>
                                  <MenuItem value="CHEQUE">Cheque</MenuItem>
                                  <MenuItem value="BANK TRANSFER">
                                    Bank Transfer
                                  </MenuItem>
                                </TextField>
                              </div>
                              <div className="input-item">
                                <label>Current Salary Income(Monthly)</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.currentSalary || ""}
                                  name={`current-salary-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'currentSalary', e.target.value)}
                                  size="small"
                                  type="number"
                                />
                              </div>
                              <div className="input-item">
                                <label>Previous Salary</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.prevSalary || ""}
                                  name={`prev-salary-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'prevSalary', e.target.value)}
                                  size="small"
                                  type="number"
                                />
                              </div>
                              <div className="input-item">
                                <label>Job Vintage (Months)</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.totalWorkExperience || ""}
                                  name={`job-vintage-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'totalWorkExperience', e.target.value)}
                                  size="small"
                                  type="number"
                                />
                              </div>
                              <div className="input-item">
                                <label>Office Number</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.officeNumber || ""}
                                  name={`office-number-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'officeNumber', e.target.value)}
                                  size="small"
                                />
                              </div>
                              <div className="input-item">
                                <label>Office HR Number</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.officeHrNumber || ""}
                                  name={`office-hr-number-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'officeHrNumber', e.target.value)}
                                  size="small"
                                  type="number"
                                />
                              </div>
                              <div className="input-item">
                                <label>Date of Joining</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.dateofJoining || ""}
                                  name={`date-of-joining-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'dateofJoining', e.target.value)}
                                  size="small"
                                  type="date"
                                  inputProps={{
                                    max: new Date().toISOString().split("T")[0],
                                  }}
                                />
                              </div>
                              <div className="input-item">
                                <label>Official Email Id
                                </label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.officialEmailId || ""}
                                  name={`Official-Email-Id-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'officialEmailId', e.target.value)}
                                  size="small"
                                  type="email"
                                />
                              </div>
                            </div>
                            <h3>Company Address</h3>
                            <div className="primary-business-address">
                              <div className="input-item">
                                <label>Address</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.companyAddress || ""}
                                  name={`company-address-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'companyAddress', e.target.value)}
                                  size="small"
                                />
                              </div>
                              <div className="input-item">
                                <label>Pin Code</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="officialPinCode"
                                  value={surrogateCoapplicantCompanyPincode}
                                  placeholder="Search Pin Code"
                                  onChange={handleSurrogateCompanyPincode}
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>State Name</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="officialState"
                                  value={surrogateCoapplicantCompanyState}
                                  disabled
                                  onChange={(e) => setsurrogateCoapplicantCompanyState(e.target.value)}
                                  placeholder="State Name"
                                  size="small"
                                />
                              </div>

                              <div className="input-item">
                                <label>City Name</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  name="officialCity"
                                  value={surrogateCoapplicantCompanyCity}
                                  disabled
                                  placeholder="City Name"
                                  onChange={(e) => setsurrogateCoapplicantCompanyCity(e.target.value)}
                                  size="small"
                                />
                              </div>
                              <div className="input-item">
                                <label>Sub District</label>
                                <br />
                                <TextField
                                  select
                                  className="input-field"
                                  name="officialSubDist"
                                  value={surrogateCoapplicantCompanySubDist}
                                  placeholder="Sub District"
                                  onChange={handleSubDistSurrogateCompanyChange}
                                  size="small"
                                >
                                  {surrogateCoapplicantCompanySubDistArr?.map(subDist => {
                                    return <MenuItem key={subDist} value={subDist}>{subDist}</MenuItem>
                                  })}
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Locality/Village</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  select
                                  helperText={negativeAreaCompanySurrogate ? 'Negative Area' : ''}
                                  error={negativeAreaCompanySurrogate}
                                  name="officialLocality"
                                  value={surrogateCoapplicantCompanyLocality}
                                  placeholder="Locality/Village"
                                  onChange={(e) => checkNegativeSurrogateCompanyArea(e.target.value, setsurrogateCoapplicantCompanyLocality, 'companyLocality')}
                                  size="small"
                                >
                                  {surrogateCoapplicantCompanyLocalityArr?.map(locality => {
                                    return <MenuItem key={locality} value={locality}>{locality}</MenuItem>
                                  })}
                                </TextField>
                              </div>

                              <div className="input-item">
                                <label>Landmark</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.companyLandmark || ""}
                                  name={`company-landmark-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'companyLandmark', e.target.value)}
                                  size="small"
                                />
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    ))}
                    <br />
                    {demoTypes.map((demoType, index) => (
                      demoType === "SELF-EMPLOYED" ? (
                        <>
                          <div className="bank-details">
                            <div className="input-item">
                              <label>Business Type</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                size="small"
                                name={`type-of-business-${index}`}
                                value={formData[index]?.typeOfBusiness || ""}
                                onChange={(e) => handleSurrogateInputChange(index, 'typeOfBusiness', e.target.value)}
                              >
                                <MenuItem value="GROCERY">Grocery</MenuItem>
                                <MenuItem value="DAIRY">Dairy (CO-OPERATIVE)</MenuItem>
                                <MenuItem value="VEGETABLE">Vegetable</MenuItem>
                                <MenuItem value="MEDICAL">Medical</MenuItem>
                                <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                                <MenuItem value="Trading">Trading</MenuItem>
                                <MenuItem value="Agriculture">Agriculture</MenuItem>
                                <MenuItem value="Services">Services</MenuItem>
                                <MenuItem value="Flour Mill">Flour Mill</MenuItem>
                                <MenuItem value="Diagnostic Centre (cattle/human)">Diagnostic Centre (cattle/human)</MenuItem>
                                <MenuItem value="Other">Other</MenuItem>
                              </TextField>
                            </div>
                            {formData[index]?.typeOfBusiness !== 'DAIRY' ?
                              (<div className="input-item">
                                <label>Business Name</label>
                                <br />
                                <TextField
                                  className="input-field"
                                  value={formData[index]?.businessName || ""}
                                  name={`business-name-${index}`}
                                  onChange={(e) => handleSurrogateInputChange(index, 'businessName', e.target.value)}
                                  size="small"
                                />
                              </div>) : (<div className="input-item">
                                <label>Mandli Name</label>
                                <Autocomplete
                                  id={`mandli-${index}`}
                                  disablePortal
                                  options={mandliArr}
                                  size="small"
                                  onChange={handleMandliChange}
                                  sx={{ width: '36vw' }}
                                  renderInput={(params) => <TextField {...params} onChange={mandliSuggestions} />}
                                />
                              </div>)}
                            {formData[index]?.typeOfBusiness === "DAIRY" ?
                              <>
                                <div className="input-item">
                                  <label>Mantri Name</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={formData[index]?.mantriName || ""}
                                    name={`mantri-name-${index}`}
                                    onChange={(e) => handleSurrogateInputChange(index, 'mantriName', e.target.value)}
                                    size="small"
                                  />
                                </div>
                                <div className="input-item">
                                  <label>Mantri Number</label>
                                  <br />
                                  <TextField
                                    className="input-field"
                                    value={formData[index]?.mantriNumber || ""}
                                    name={`mantri-number-${index}`}
                                    onChange={(e) => handleSurrogateInputChange(index, 'mantriNumber', e.target.value)}
                                    size="small"
                                  />
                                </div>
                              </>
                              : ""}
                            <div className="input-item">
                              <label>Business Income(Monthly)</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={formData[index]?.businessIncome || ""}
                                name={`business-income-${index}`}
                                onChange={(e) => handleSurrogateInputChange(index, 'businessIncome', e.target.value)}
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Business Vintage (Months)</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={formData[index]?.businessVintage || ""}
                                name={`business-vintage-${index}`}
                                onChange={(e) => handleSurrogateInputChange(index, 'businessVintage', e.target.value)}
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Income Mode</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={formData[index]?.businessIncomeMode || ""}
                                name={`business-income-mode-${index}`}
                                onChange={(e) => handleSurrogateInputChange(index, 'businessIncomeMode', e.target.value)}
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Business Email Id
                              </label>
                              <br />
                              <TextField
                                className="input-field"
                                value={formData[index]?.businessEmailId || ""}
                                name={`Business-Email-Id-${index}`}
                                onChange={(e) => handleSurrogateInputChange(index, 'businessEmailId', e.target.value)}
                                size="small"
                                type="email"
                              />
                            </div>
                          </div>
                          <h3>Business Address</h3>
                          <div className="primary-business-address">
                            <div className="input-item">
                              <label>Address</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={formData[index]?.businessAddress || ""}
                                name={`business-address-${index}`}
                                onChange={(e) => handleSurrogateInputChange(index, 'businessAddress', e.target.value)}
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Pin Code</label>
                              <br />
                              <TextField
                                className="input-field"
                                name="officialPinCode"
                                value={surrogateCoapplicantBusinessPincode}
                                placeholder="Search Pin Code"
                                onChange={handleSurrogateBusinessPincode}
                                size="small"
                              />
                            </div>

                            <div className="input-item">
                              <label>State Name</label>
                              <br />
                              <TextField
                                className="input-field"
                                name="officialState"
                                value={surrogateCoapplicantBusinessState}
                                disabled
                                onChange={(e) => setsurrogateCoapplicantBusinessState(e.target.value)}
                                placeholder="State Name"
                                size="small"
                              />
                            </div>

                            <div className="input-item">
                              <label>City Name</label>
                              <br />
                              <TextField
                                className="input-field"
                                name="officialCity"
                                value={surrogateCoapplicantBusinessCity}
                                disabled
                                placeholder="City Name"
                                onChange={(e) => setsurrogateCoapplicantBusinessCity(e.target.value)}
                                size="small"
                              />
                            </div>
                            <div className="input-item">
                              <label>Sub District</label>
                              <br />
                              <TextField
                                select
                                className="input-field"
                                name="officialSubDist"
                                value={surrogateCoapplicantBusinessSubDist}
                                placeholder="City Name"
                                onChange={handleSubDistSurrogateBusinessChange}
                                size="small"
                              >
                                {surrogateCoapplicantBusinessSubDistArr?.map(subDist => {
                                  return <MenuItem key={subDist} value={subDist}>{subDist}</MenuItem>
                                })}
                              </TextField>
                            </div>

                            <div className="input-item">
                              <label>Locality/Village</label>
                              <br />
                              <TextField
                                className="input-field"
                                select
                                helperText={negativeAreaBusinessSurrogate ? 'Negative Area' : ''}
                                error={negativeAreaBusinessSurrogate}
                                name="officialLocality"
                                value={surrogateCoapplicantBusinessLocality}
                                placeholder="Locality/Village"
                                onChange={(e) => checkNegativeSurrogateBusinessArea(e.target.value, setsurrogateCoapplicantBusinessLocality, 'businessLocality')}
                                size="small"
                              >
                                {surrogateCoapplicantBusinessLocalityArr?.map(locality => {
                                  return <MenuItem key={locality} value={locality}>{locality}</MenuItem>
                                })}
                              </TextField>
                            </div>

                            <div className="input-item">
                              <label>Landmark</label>
                              <br />
                              <TextField
                                className="input-field"
                                value={formData[index]?.businessLandmark || ""}
                                name={`business-landmark-${index}`}
                                onChange={(e) => handleSurrogateInputChange(index, 'businessLandmark', e.target.value)}
                                size="small"
                              />
                            </div>
                          </div>
                        </>
                      ) : null
                    ))}
                    <br />
                    <Button variant="contained" onClick={handleAddSurrogate}>Add</Button>
                  </AccordionDetails >
                  <div className="btns-add-borrower">
                    <Button
                      variant="contained"
                      color="success"
                      type="submit"
                      style={{ marginRight: "1rem" }}
                    >
                      Update
                    </Button>
                  </div>
                </form>
              </Accordion>

              <Accordion className="menu-item-add-borrower">
                <AccordionSummary
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <h3 className="accordian-header" style={{ fontWeight: "bold" }}>
                    Obligations
                  </h3>
                </AccordionSummary>
                <form action="" onSubmit={handleObligationDetails}>
                  <AccordionDetails>
                    <div className="bank-details">
                      <div className="input-item">
                        <label>Number of Active Loans</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={coapplicantnumberOfActiveLoans}
                          name="number-of-active-loans"
                          onChange={(e) =>
                            setcoapplicantnumberOfActiveLoans(e.target.value)
                          }
                          placeholder="Number of Active Loans"
                          size="small"
                        />
                      </div>
                      <div className="input-item">
                        <label>Total Monthly Active EMI Amount</label>
                        <br />
                        <TextField
                          className="input-field"
                          value={coapplicanttotalMonthlyActiveEmiAmount}
                          name="total-monthly-active-emi-amount"
                          onChange={(e) =>
                            setcoapplicanttotalMonthlyActiveEmiAmount(e.target.value)
                          }
                          placeholder="Total Monthly Active EMI Amount"
                          size="small"
                        />
                      </div>
                    </div>
                  </AccordionDetails>
                  <div className="btns-add-borrower">
                    <Button
                      variant="contained"
                      color="success"
                      type="submit"
                      style={{ marginRight: "1rem" }}
                    >
                      Update
                    </Button>
                  </div>
                </form>
              </Accordion>

              {isAddDoc && (
                <Accordion className="accordian-coapp" sx={accordianSX}>
                  <AccordionSummary
                    sx={mainAccordian}
                    id="panel3-header"
                    aria-controls="panel3-content"
                    expandIcon={<ExpandMoreOutlined />}
                  >
                    <h3 className="accordian-header">Co-applicant Documents</h3>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      Important: Size of documents must not exceed 1 MB*
                    </p>
                    <br />
                    <Accordion className="menu-item-add-borrower">
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p style={{ fontStyle: "italic" }}>KYC Documents</p>
                      </AccordionSummary>

                      <AccordionDetails>
                        <div className="docs-add-borrower">
                          <div style={{ display: "flex", gap: "2rem" }}>
                            <button
                              className="digi-kyc"
                              onClick={() => handleEkyc("reinitiate/link")}
                            >
                              Reinitiate Session
                            </button>
                            <button
                              className="digi-kyc"
                              onClick={() => handleEkyc("fetch/link")}
                            >
                              Fetch Link
                            </button>
                            <button
                              className="digi-kyc"
                              onClick={() => handleEkyc("fetch/data")}
                            >
                              Fetch Data
                            </button>
                            <button
                              className="digi-kyc"
                              onClick={copyLinkToClipboard}
                            >
                              Copy Link
                            </button>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <label>eKyc Mode :</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>
                              {ekycMode}
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <label>eKyc Status :</label>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>
                              {ekycStatus}
                            </div>
                            {/* <div className="input-item">
                      <TextField
                        className="input-field"
                        name="ekycStatus"
                        value={ekycStatus}
                        disabled
                        size="small"
                        type="text"
                      />
                    </div> */}
                          </div>

                          <div className="input-item-doc">
                            <label style={{ fontWeight: "bold" }}>Self Photo</label>
                            <input
                              required
                              type="file"
                              name="self-photo"
                              onChange={(e) => uploadSelfPhoto(e)}
                            />
                            {coapplicant_selfphoto ? (
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="input-item-doc-5">
                            <label style={{ fontWeight: "bold" }}>Pancard</label>
                            <input
                              required
                              type="file"
                              name="pancard"
                              onChange={(e) => uploadPancard(e)}
                            />
                            {coapplicant_pan ? (
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="input-item-doc">
                            <label style={{ display: "flex", gap: "1rem" }}>
                              <input
                                type="checkbox"
                                checked={form60Available}
                                onChange={handleCheckboxChange}
                              />
                              Is Form 60 Available?
                            </label>
                          </div>

                          {form60Available && (
                            <div className="input-item-doc">
                              <label style={{ fontWeight: "bold" }}>
                                Co-Applicant Form 60
                              </label>
                              <input
                                type="file"
                                required
                                name="coapplicant-form-60"
                                onChange={(e) => uploadCoapplicantForm60(e)}
                              />
                              {coapplicant_form60 ? (
                                <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                              ) : (
                                ""
                              )}
                            </div>
                          )}

                          <div className="input-item-doc-4">
                            <label style={{ fontWeight: "bold" }}>
                              Aadhar Card Front
                            </label>
                            <input
                              type="file"
                              required
                              name="aadhar-card-front"
                              onChange={(e) => uploadAadharCardFront(e)}
                            />
                            {coapplicant_aadhar_front ? (
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ) : (
                              ""
                            )}
                          </div>

                          <div className="input-item-doc">
                            <label style={{ fontWeight: "bold" }}>
                              Aadhar Card Back
                            </label>
                            <input
                              type="file"
                              name="aadhar-card-back"
                              required
                              onChange={(e) => uploadAadharCardBack(e)}
                            />
                            {coapplicant_aadhar_back ? (
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ) : (
                              ""
                            )}
                            <button
                              className="digi-kyc"
                              onClick={uploadAadharCard}
                            >
                              Upload Aadhar Front and Back
                            </button>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5.2rem",
                            }}
                          >
                            <label style={{ fontWeight: "bold" }}>
                              Other KYC Documents
                            </label>

                            <div style={{ width: "30%" }}>
                              <Select
                                value={kycDocuments}
                                onChange={(e) => handlekycdocuments(e)}
                                options={kyc}
                                isMulti
                              // inputProps={{ autoComplete: 'off'}}
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          {kycDocuments?.length > 0 &&
                            kycDocuments?.map((val) => KycBox(val.label))}
                        </div>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion className="menu-item-add-borrower">
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p style={{ fontStyle: "italic" }}>Income Documents</p>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="input-item-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Bank Statement
                          </label>
                          <input
                            type="file"
                            required
                            name="bank-statement"
                            onChange={(e) => uploadBankStatement(e)}
                          />
                          {coapplicant_bank_statement.length > 0 ? (
                            <div>
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                              ({coapplicant_bank_statement.length})
                            </div>

                          ) : (
                            ""
                          )}
                        </div>
                        <div className="input-item-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Bank Statement Password (If Bank Statement Password
                            Protected)
                          </label>
                          <div className="input-item">
                            <TextField
                              name="bank_statement_password"
                              className="input-field-document"
                              value={password}
                              type="password"
                              size="small"
                              placeholder="Password"
                              onChange={(e) => setPassword(e.target.value)}
                              autoComplete="new-password"
                            />
                          </div>
                          <button
                            className="digi-kyc"
                            onClick={handleSubmitBankStatement}
                          >
                            Upload Bank Statement
                          </button>
                        </div>
                        <div className="input-bank-statement-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Bank report Documents
                          </label>
                          <input
                            type="file"
                            name="bank-report"
                            onChange={(e) => uploadBankReportDocuments(e)}
                          />

                          {coapplicant_bank_report_documents.length > 0 ? (
                            <div>
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                              ({coapplicant_bank_report_documents.length})
                            </div>

                          ) : (
                            ""
                          )}

                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4rem",
                          }}
                        >
                          <label style={{ fontWeight: "bold" }}>
                            Other Income Documents
                          </label>
                          <div style={{ width: "30%" }}>
                            <Select
                              value={incomeDocuments}
                              className="select-box"
                              onChange={(e) => handleincomedocuments(e)}
                              options={Income}
                              isMulti
                            />
                          </div>
                        </div>

                        <div>
                          {incomeDocuments?.length > 0 &&
                            incomeDocuments?.map((val) => incomeBox(val.label))}
                        </div>

                      </AccordionDetails>
                    </Accordion>

                    <Accordion className="menu-item-add-borrower">
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p style={{ fontStyle: "italic" }}>
                          Employement Proof Documents
                        </p>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className="docs-add-borrower">

                          {coapplicantProfession === "SALARIED" ? (
                            <>
                              <div className="input-item-doc">
                                <label style={{ fontWeight: "bold" }}>Company ID</label>
                                <input
                                  required
                                  type="file"
                                  name="self-photo"
                                  onChange={(e) => uploadCompanyId(e)}
                                />
                                {coapplicant_companyid ? (
                                  <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="input-item-doc">
                                <label style={{ fontWeight: "bold" }}>Appointment Letter</label>
                                <input
                                  required
                                  type="file"
                                  name="self-photo"
                                  onChange={(e) => uploadAppointmentLetter(e)}
                                />
                                {coapplicant_appointment_letter.length > 0 ? (
                                  <div>
                                    <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                                    ({coapplicant_appointment_letter.length})
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "2rem",
                                }}
                              >
                                <label style={{ fontWeight: "bold" }}>
                                  Other Employement Proof Documents
                                </label>

                                <div style={{ width: "30%" }}>
                                  <Select
                                    value={employementDocuments}
                                    className="select-box"
                                    onChange={(e) => handleemployeedocuments(e)}
                                    options={Employement}
                                    isMulti
                                  />
                                </div>
                              </div>

                              <div>
                                {employementDocuments?.length > 0 &&
                                  employementDocuments?.map((val) =>
                                    employeBox(val.label)
                                  )}
                              </div>
                            </>
                          ) : null}

                          {coapplicantProfession === "SELF-EMPLOYED" ? (
                            <>
                              <div className="input-item-doc">
                                <label style={{ fontWeight: "bold" }}> Electricity Bill</label>
                                <input
                                  required
                                  type="file"
                                  name="self-photo"
                                  onChange={(e) => uploadElectricityBill(e)}
                                />
                                {coapplicant_electricity_bill.length > 0 ? (
                                  <div>
                                    <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                                    ({coapplicant_electricity_bill.length})
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div className="input-item-doc">
                                <label style={{ fontWeight: "bold" }}> Milk Statement </label>
                                <input
                                  required
                                  type="file"
                                  name="self-photo"
                                  onChange={(e) => uploadMilkStatement(e)}
                                />
                                {coapplicant_milkstatement.length > 0 ? (
                                  <div>
                                    <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                                    ({coapplicant_milkstatement.length})
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="input-item-doc">
                                <label style={{ fontWeight: "bold" }}>Business Photo</label>
                                <input
                                  required
                                  type="file"
                                  name="business-photo"
                                  onChange={(e) => uploadBusinessPhoto(e)}
                                />
                                {coapplicant_inside_shop_photo.length > 0 ? (
                                  <div>
                                    <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                                    ({coapplicant_inside_shop_photo.length})
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "1.5rem",
                                }}
                              >
                                <label style={{ fontWeight: "bold" }}>
                                  Business Registration Proof
                                </label>
                                <br />

                                <div style={{ width: "30%" }}>
                                  <Select
                                    value={businessProof}
                                    className="select-box"
                                    onChange={(e) => handlebusinessdocuments(e)}
                                    options={Business}
                                    isMulti
                                  />
                                </div>
                              </div>

                              <div>
                                {businessProof?.length > 0 &&
                                  businessProof?.map((val) =>
                                    businessBox(val.label)
                                  )}
                              </div>
                            </>
                          ) : null}

                        </div>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion className="menu-item-add-borrower">
                      <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        expandIcon={<ExpandMoreIcon />}
                      >
                        <p style={{ fontStyle: "italic" }}>Other Documents</p>
                      </AccordionSummary>
                      <AccordionDetails>

                        <div className="input-item-doc">
                          <label style={{ fontWeight: "bold" }}>
                            Miscellaneous Documents
                          </label>
                          <input
                            type="file"
                            name="miscellaneous-documents"
                            onChange={(e) => uploadMiscellaneousDocuments(e)}
                          />
                          {coapplicant_misc_doc.length > 0 ? (
                            <div>
                              <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                              ({coapplicant_misc_doc.length})
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {/* <div className="input-item-doc">
                        <label style={{ fontWeight: "bold" }}>
                          Cibil Report
                        </label>
                        <input
                          type="file"
                          name="cibil-report"
                          onChange={(e) => uploadcibilReport(e)}
                        />
                        {coapplicant_cibil_report.length > 0 ? (
                          <div>
                            <TaskIcon sx={{ color: "green", fontSize: "2rem" }} />
                            ({coapplicant_cibil_report.length})
                          </div>
                        ) : (
                          ""
                        )}
                      </div> */}
                      </AccordionDetails>
                    </Accordion>
                  </AccordionDetails>
                </Accordion>
              )}

              <div className="form-btns" style={{}}>
                <Link to="/coapplicant/view">
                  <Button variant="contained">View Coapplicants</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div >
    </>
  );
};

export default EditCoApplicant;
